(function () {
    var $body = document.body,
        $doc = document,
        $html = document.documentElement,
        $win = window,
        sliderNavHTML;

    // Safety mock for missing animation functions to prevent console errors and INP spikes
    window.sharedFunctionsAnimation = window.sharedFunctionsAnimation || {
        onEnterButton: function () { },
        onLeaveButton: function () { }
    };

    // Remove jQuery ajaxStart/ajaxStop - not needed in vanilla JS
    // These were used to track AJAX loading state, but we can handle this differently if needed

    var halo = {
        haloTimeout: null,
        isAjaxLoading: false,

        ready: function () {
            this.loaderScript();
            this.loaderProductBlock();

            if (navigator.userAgent.match(/Mac OS X.*(?:Safari|Chrome)/) && !navigator.userAgent.match(/Chrome/)) {
                document.body.classList.add('safari')
            } else {
                document.body.classList.add('chrome')
            }

            if (typeof InstallTrigger !== 'undefined') document.body.classList.add('firefox');

            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            if (isIOS) document.body.classList.add('iOS')

            if ($body.classList.contains('template-product')) {
                this.loaderRecommendationsBlock();
            }

            if (document.querySelectorAll('[data-product-tab-block]').length) {
                // this.clickedActiveProductTabs(); // Moved to product-tabs.js module (auto-initialized)
            }

            if ($body.classList.contains('product-card-layout-07')) {
                this.calculateTranslateYHeight()
            }

            window.sharedFunctions = window.sharedFunctions || {};
            Object.assign(window.sharedFunctions, {
                // setLocalStorageProductForWishlist moved to wishlist.js module
                checkNeedToConvertCurrency: this.checkNeedToConvertCurrency,
                productBlockSilder: this.productBlockSilder,
                calculateTranslateYHeight: this.calculateTranslateYHeight,
                productCountdownCard: halo.productCountdownCard,
                swapHoverVideoProductCard: halo.swapHoverVideoProductCard,
                // updateSidebarCart moved to cart-sidebar.js module
                updateSidebarCart: function (cart) {
                    // Tentar chamar via window.sharedFunctions que é onde o cart-sidebar.js exporta
                    if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function' && window.sharedFunctions.updateSidebarCart !== this.updateSidebarCart) {
                        window.sharedFunctions.updateSidebarCart(cart);
                    }
                },

                updatePopupCart: function (cart, layout, variantId) {
                    if (window.sharedFunctions && typeof window.sharedFunctions.updatePopupCart === 'function' && window.sharedFunctions.updatePopupCart !== this.updatePopupCart) {
                        window.sharedFunctions.updatePopupCart(cart, layout, variantId);
                    }
                },
            });
        },

        init: function () {
            // this.initMultiTab(); // Moved to menu-mobile.js module (auto-initialized)
            // this.initMultiTabMobile(); // Moved to menu-mobile.js module (auto-initialized)
            // this.productBlockInfiniteScroll(); // Moved to product-block-infinite.js module (auto-initialized)
            this.initGlobalCheckbox();
            this.initPanelSequenceSelector();
            this.initColorSwatch();
            // this.initAddToCart(); // Moved to add-to-cart.js module (auto-initialized após theme.js)
            // this.initQuickShop(); // Moved to quick-shop.js module (auto-initialized após theme.js)
            // this.initQuickCart(); // Moved to cart-sidebar.js module (auto-initialized após theme.js)
            // this.initNotifyInStock(); // Moved to notify-in-stock.js module (auto-initialized após theme.js)
            // this.initCompareProduct(); // Moved to compare-product.js module (auto-initialized após theme.js)
            // this.initWishlist(); // Moved to wishlist.js module (auto-initialized após theme.js)
            // this.initAskAnExpert(); // Moved to ask-an-expert.js module (auto-initialized após theme.js)
            this.initHeader();
            this.headerLanguageCurrency();
            this.headerMasonry();
            this.initMenuDropdownLazyLoad();
            this.initLiveChat();
            this.headerSidebarSearch();
            this.headerStickySearchForm();
            // this.initCountdown(); // Moved to countdown.js module (auto-initialized)
            // this.collectionCountdown(); // Moved to countdown.js module (auto-initialized)
            this.handleScrollDown();
            // this.initVideoPopup(); // Moved to video-popup.js module (auto-initialized)
            // this.swapHoverVideoProductCard(); // Moved to video-popup.js module (auto-initialized)
            this.initDynamicBrowserTabTitle();
            // this.initWarningPopup(); // Moved to warning-popup.js module (auto-initialized)
            this.clickIconScrollSection();
            this.specialBanner();
            // this.formMessage(); // Moved to form-message.js module (auto-initialized)
            this.typingAnimation();
            this.initCentralizedOverlay();
            // this.spotlightproductSlider(); // Moved to spotlight-product-swiper.js module (auto-initialized)
            // this.doBeforeMegaMenuProductBlock(); // Moved to mega-menu-product.js module (auto-initialized)

            if (document.querySelectorAll('.lookbook-carousel').length) {
                this.lookbookCarousel();
            }

            // Init Quick View - Moved to quick-view.js module (auto-initialized)
            // if (window.quick_view.show || window.quick_view.show_mb) {
            //     this.initQuickView();
            // }

            // Init Mobile Menu
            if (window.innerWidth < 1025) {
                // this.menuSidebarMobile(); // Moved to menu-mobile.js module (auto-initialized)
                // this.menuSidebarMobileToggle(); // Moved to menu-mobile.js module (auto-initialized)
            }

            // Check Lazyload Done
            const loadingImages = document.querySelectorAll('.media--loading-effect img')
            const productGrid = document.getElementById('main-collection-product-grid')

            if (loadingImages.length > 0 || productGrid) {
                this.initLazyloadObserver(loadingImages, productGrid);
            }

            if ($body.classList.contains('show_effect_close')) {
                this.backgroundOverlayHoverEffect();
                this.backgroundOverlayHoverEffect1();
            }

            if ($body.classList.contains('template-cart')) {
                this.updateGiftWrapper();
                this.activeCheckboxStickyCartMobile();
            }

            const productDetails = document.querySelector('.product-details');
            if ($body.classList.contains('template-product') || (productDetails && productDetails.classList.contains('featured-product'))) {
                const productView = document.querySelector('.halo-productView');
                // this.initProductView(productView); // Moved to product-view.js module (auto-initialized)
                this.initProductBundle();
                this.articleGallery();
                this.toggleSidebarMobile();
                this.initCollapseSidebarBlock();
                this.initCategoryActive();
                this.productCustomInformation();
                this.iconZoomClickMobile();
                this.productBlockSilderSidebar();
            }

            if ($body.classList.contains('template-blog') || $body.classList.contains('template-article')) {
                this.initCollapseSidebarBlock();
                this.initCategoryActive();
                this.toggleSidebarMobile();
                this.initBlogMasonry();
                this.productBlockSilderSidebar();
                this.productBlockSilderArticle();
            }

            if ($body.classList.contains('template-article')) {
                this.articleGallery();
            }

            if ($body.classList.contains('template-collection') || $body.classList.contains('template-search')) {
                this.initCollapseSidebarBlock();
                this.initCategoryActive();
                this.toggleSidebarMobile();
                this.productBlockSilderSidebar();
                // this.initInfiniteScrolling(); // Moved to infinite-scrolling.js module (auto-initialized)
                // this.initQuickShopProductList(); // Moved to quick-shop.js module (auto-initialized)
            }

            if ($body.classList.contains('template-list-collections')) {
                this.toggleSidebarMobile();
                this.productBlockSilderSidebar();
            }

            if ($body.classList.contains('template-collection') && document.querySelectorAll('.collection-express-order').length) {
                // this.toggleVariantsForExpressOrder(); // Moved to express-order.js module (auto-initialized)
                // this.initExpressOrderAddToCart(); // Moved to express-order.js module (auto-initialized)
            }

            if ($body.classList.contains('product-card-layout-08')) {
                halo.productCountdownCard();
            }

            halo.checkScrollLayoutForRecenlyViewed();


            let checkMenuMobile;
            window.innerWidth > 1024 ? checkMenuMobile = true : checkMenuMobile = false;

            $win.addEventListener('resize', () => {
                this.headerSidebarSearch();
                this.specialBanner();
                this.specialBannerSlider();
                this.unsymmetricalSlider();
                // this.doBeforeMegaMenuProductBlock(); // Moved to mega-menu-product.js module (auto-initialized)
                if (window.innerWidth > 1024) {
                    document.body.classList.remove('menu_open')
                } else if (checkMenuMobile) {
                    checkMenuMobile = false;
                    // this.menuSidebarMobile() // Moved to menu-mobile.js module (auto-initialized)
                    // this.menuSidebarMobileToggle() // Moved to menu-mobile.js module (auto-initialized)
                    // this.initMultiTab() // Moved to menu-mobile.js module (auto-initialized)
                    // this.initMultiTabMobile() // Moved to menu-mobile.js module (auto-initialized)
                }
            });
        },

        checkNeedToConvertCurrency: function () {
            return (window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        },

        loaderScript: function () {
            // Nova implementação usando IntersectionObserver para evitar Layout Thrashing no scroll
            if (!('IntersectionObserver' in window)) return;

            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const element = entry.target;
                        const link = element.getAttribute('data-loader-script');

                        // Garante que não carregue repetidamente
                        if (!element.classList.contains('is-load') && link) {
                            halo.buildScript(link);
                            // Marca todos os elementos com esse script como carregados
                            document.querySelectorAll('[data-loader-script="' + link + '"]').forEach(el => el.classList.add('is-load'));
                        }

                        // Para de observar este elemento específico
                        obs.unobserve(element);
                    }
                });
            }, {
                rootMargin: '100px 0px 100px 0px', // Carrega um pouco antes de aparecer
                threshold: 0.01
            });

            // Seleciona e observa elementos
            const scripts = document.querySelectorAll('[data-loader-script]:not(.is-load)');
            scripts.forEach(element => observer.observe(element));
        },

        initPanelSequenceSelector: function () {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', function () {
                    halo.initPanelSequenceSelectorHandler();
                });
            } else {
                halo.initPanelSequenceSelectorHandler();
            }
        },

        initPanelSequenceSelectorHandler: function () {
            const panelContainer = document.getElementById('panel-selection-container');
            if (!panelContainer) return;

            const pecas = document.querySelectorAll('.peca');
            const botaoPainel = document.getElementById('product-add-to-cart');
            window.selecionadas = new Set(); // Agora global
            let minSelecionado = null;
            let maxSelecionado = null;

            const btnChoosePanel = document.getElementById('btn-choose-panel');
            if (btnChoosePanel) {
                // Evitar múltiplos listeners apenas no botão
                if (!this.btnChoosePanelHandler) {
                    this.btnChoosePanelHandler = (e) => {
                        e.preventDefault();

                        // Optimize INP: Immediately disable buttons to prevent double clicks
                        // and yield to the browser to paint the button's clicked state.
                        const buttons = document.querySelectorAll('.product-form__buttons .button');
                        buttons.forEach(btn => btn.disabled = true);

                        // Small delay (50ms) to allow the browser to process the interaction and paint.
                        // This ensures the main thread is not blocked during the critical paint window.
                        setTimeout(() => {
                            if (typeof Fancybox !== 'undefined') {
                                Fancybox.show([{ src: '#panel-selection-container' }]);
                            }

                            window.selecionadas.clear();
                            const selecionados = document.querySelector('.selecionados');
                            if (selecionados) selecionados.textContent = '0';

                            const pecaInputs = document.querySelectorAll('.peca-input');
                            pecaInputs.forEach(input => input.checked = false);
                        }, 50);
                    };
                    btnChoosePanel.addEventListener('click', this.btnChoosePanelHandler);
                }
            }

            if (botaoPainel) botaoPainel.setAttribute('disabled', 'true');
            pecas.forEach((peca, i) => {
                peca.style.left = `${i * 10}%`;
            });

            document.addEventListener('click', function (event) {
                if (event.target.closest('.peca')) {
                    const peca = event.target.closest('.peca');
                    const numero = Number(peca.getAttribute('data-numero'));
                    const infoModal = peca.closest('.info-modal');

                    // Toggle da seleção: se já está selecionado, remove; se não está, adiciona
                    if (window.selecionadas.has(numero)) {
                        window.selecionadas.delete(numero);
                        console.log('Painel removido:', numero, 'Selecionados:', Array.from(window.selecionadas));
                    } else {
                        window.selecionadas.add(numero);
                        console.log('Painel adicionado:', numero, 'Selecionados:', Array.from(window.selecionadas));
                    }

                    // Atualizar min e max apenas para referência (não criar intervalos)
                    if (window.selecionadas.size > 0) {
                        const numerosArray = Array.from(window.selecionadas).sort((a, b) => a - b);
                        minSelecionado = numerosArray[0];
                        maxSelecionado = numerosArray[numerosArray.length - 1];
                    } else {
                        minSelecionado = null;
                        maxSelecionado = null;
                    }

                    atualizarSelecao(peca, infoModal);
                }
            });

            // Removido: não limpar seleção ao clicar no botão, apenas após envio bem-sucedido
            // A limpeza será feita no add-to-cart.js após o sucesso do envio

            function atualizarSelecao(target, infoModal) {
                // Buscar peças dentro do modal (pode ser o original ou o clone)
                const pecasNoModal = infoModal ? infoModal.querySelectorAll('.peca') : document.querySelectorAll('.peca');

                // Atualizar TODOS os inputs baseado no Set window.selecionadas
                // Isso garante que todos os valores selecionados sejam enviados no formulário
                const inputsAtualizados = [];
                document.querySelectorAll('.peca-input').forEach(function (input) {
                    const numero = Number(input.value);
                    const idNumero = Number(input.id.replace('peca-', ''));
                    const numeroParaComparar = numero || idNumero;

                    if (window.selecionadas.has(numeroParaComparar)) {
                        input.checked = true;
                        input.setAttribute('checked', 'checked');
                        inputsAtualizados.push({ numero: numeroParaComparar, name: input.name, checked: true });
                    } else {
                        input.checked = false;
                        input.removeAttribute('checked');
                    }
                });
                console.log('Inputs atualizados:', inputsAtualizados);

                // Atualizar visual das peças no modal
                pecasNoModal.forEach(function (peca) {
                    const numero = Number(peca.getAttribute('data-numero'));
                    if (window.selecionadas.has(numero)) {
                        peca.classList.add('selecionada');
                    } else {
                        peca.classList.remove('selecionada');
                    }
                });

                // Atualizar contador dentro do modal
                const selecionados = infoModal ? infoModal.querySelector('.selecionados') : document.querySelector('.selecionados');
                if (selecionados) selecionados.textContent = `${window.selecionadas.size}`;

                const quantidadeTotalEl = infoModal ? infoModal.querySelector('#quantidade-total') : document.getElementById('quantidade-total');
                const quantidadeTotal = quantidadeTotalEl ? Number(quantidadeTotalEl.textContent) : 0;

                // Atualizar quantity input no formulário principal (não no clone)
                const quantityInput = document.querySelector('.product-form input[name="quantity"]');
                if (quantityInput) quantityInput.value = window.selecionadas.size;

                // Atualizar botão dentro do modal
                if (infoModal) {
                    const button = infoModal.querySelector('.product-form__buttons > button');
                    if (button) {
                        if (window.selecionadas.size >= quantidadeTotal) {
                            button.removeAttribute('disabled');
                        } else {
                            button.setAttribute('disabled', 'true');
                        }
                    }
                }
            }

            // Limpar seleção quando o Fancybox fechar
            if (typeof Fancybox !== 'undefined' && !this.fancyboxCloseHandler) {
                const limparSelecao = () => {
                    const panelSelection = document.getElementById('panel-selection-container');
                    if (panelSelection) {
                        // Limpar seleção quando o popup fechar
                        if (window.selecionadas) {
                            window.selecionadas.clear();
                        }

                        document.querySelectorAll('product-form .peca-input').forEach(input => {
                            input.checked = false;
                        });
                        document.querySelectorAll('.peca.selecionada').forEach(el => {
                            el.classList.remove('selecionada');
                        });

                        // Atualizar contador
                        const selecionados = document.querySelector('.selecionados');
                        if (selecionados) selecionados.textContent = '0';
                    }
                };

                // Tentar múltiplos eventos do Fancybox para garantir compatibilidade
                this.fancyboxCloseHandler = limparSelecao;
                document.addEventListener('fancybox:close', limparSelecao);
                document.addEventListener('fancybox.close', limparSelecao);

                // Observer para detectar quando o modal sai do DOM
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        mutation.removedNodes.forEach((node) => {
                            if (node.nodeType === 1 && (node.id === 'panel-selection-container' || node.querySelector('#panel-selection-container'))) {
                                limparSelecao();
                            }
                        });
                    });
                });

                observer.observe(document.body, { childList: true, subtree: true });
            }
        },

        buildScript: function (name) {
            var loadScript = document.createElement("script");
            loadScript.src = name;
            document.body.appendChild(loadScript);
        },

        buildStyleSheet: function (name, $this) {
            if (name == '') return;
            const loadStyleSheet = document.createElement("link");
            loadStyleSheet.rel = 'stylesheet';
            loadStyleSheet.type = 'text/css';
            loadStyleSheet.href = name;
            $this.parentNode.insertBefore(loadStyleSheet, $this);
        },

        loaderProductBlock: function () {
            var isAjaxLoading = false;

            // Remove jQuery ajaxStart/ajaxStop - not needed in vanilla JS

            const handler = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const block = entry.target;
                        if (block.classList.contains('ajax-loaded')) return;

                        var url = block.getAttribute('data-collection'),
                            layout = block.getAttribute('data-layout'),
                            limit = block.getAttribute('data-limit'),
                            image_ratio = block.getAttribute('data-image-ratio'),
                            swipe = block.getAttribute('data-swipe'),
                            sectionId = block.getAttribute('sectionId'),
                            hasCountdown = block.getAttribute('hasCountdown');

                        if (url != null && url != undefined) {
                            block.classList.add('ajax-loaded');

                            const urlParams = new URLSearchParams({
                                view: 'ajax_product_block',
                                constraint: 'limit=' + limit + '+layout=' + layout + '+sectionId=' + sectionId + '+imageRatio=' + image_ratio + '+swipe=' + swipe + '+hasCountdown=' + hasCountdown
                            });

                            fetch(window.routes.root + '/collections/' + url + '?' + urlParams.toString(), {
                                method: 'GET',
                                cache: 'no-store'
                            })
                                .then(response => response.text())
                                .then(data => {
                                    if (url != '') {
                                        const parser = new DOMParser();
                                        const doc = parser.parseFromString(data, 'text/html');
                                        const products = doc.querySelectorAll('.product');
                                        const productsArray = Array.from(products);
                                        const res = halo.handleResponse(productsArray, 0, limit);

                                        const htmlContent = res.map(el => el.outerHTML).join('');

                                        if (layout == 'grid') {
                                            const productsGrid = block.querySelector('.products-grid');
                                            if (productsGrid) productsGrid.innerHTML = htmlContent;
                                        } else if (layout == 'slider') {
                                            const productsCarousel = block.querySelector('.products-carousel');
                                            if (productsCarousel) {
                                                // Destroy existing Swiper instance if present
                                                if (productsCarousel.swiperInstance) {
                                                    productsCarousel.swiperInstance.destroy(true, true);
                                                    productsCarousel.classList.remove('swiper-initialized');
                                                    delete productsCarousel.swiperInstance;
                                                }
                                                productsCarousel.innerHTML = htmlContent;
                                            }
                                        } else if (layout == 'scroll') {
                                            const productsFlex = block.querySelector('.products-flex');
                                            if (productsFlex) productsFlex.innerHTML = htmlContent;
                                        }

                                        block.querySelectorAll('.card .variants-popup-content .selector-wrapper .swatch-element').forEach(function (swatchEl) {
                                            const input = swatchEl.querySelector('input');
                                            const label = swatchEl.querySelector('label');

                                            if (input) {
                                                const currentId = input.getAttribute('id') || '';
                                                const currentName = input.getAttribute('name') || '';
                                                input.setAttribute('id', currentId + sectionId);
                                                input.setAttribute('name', currentName + sectionId);
                                            }
                                            if (label) {
                                                const currentFor = label.getAttribute('for') || '';
                                                label.setAttribute('for', currentFor + sectionId);
                                            }
                                        });

                                        block.querySelectorAll('.card').forEach(function (card) {
                                            const qsForm = card.querySelector('.variants-popup-content form');
                                            const acForm = card.querySelector('.card-action form');
                                            const select = card.querySelector('.variants-popup-content select');
                                            const acButton = card.querySelector('.card-action form button');
                                            const qsButton = card.querySelector('.variants-popup-content .product-card__button2 button');

                                            if (qsForm) {
                                                const currentId = qsForm.getAttribute('id') || '';
                                                qsForm.setAttribute('id', currentId + sectionId);
                                            }
                                            if (acForm) {
                                                const currentId = acForm.getAttribute('id') || '';
                                                acForm.setAttribute('id', currentId + sectionId);
                                            }
                                            if (select) {
                                                const currentId = select.getAttribute('id') || '';
                                                select.setAttribute('id', currentId + sectionId);
                                            }
                                            if (acButton) {
                                                const currentDataFormId = acButton.getAttribute('data-form-id') || '';
                                                acButton.setAttribute('data-form-id', currentDataFormId + sectionId);
                                            }
                                            if (qsButton) {
                                                const currentDataFormId = qsButton.getAttribute('data-form-id') || '';
                                                qsButton.setAttribute('data-form-id', currentDataFormId + sectionId);
                                            }
                                        });
                                    }

                                    // Complete handler
                                    if (layout == 'slider') {
                                        if (typeof halo.productBlockSilder === 'function') {
                                            halo.productBlockSilder(block);
                                        }
                                    }

                                    if (block.classList.contains('special-banner__product') && layout == 'grid' && window.innerWidth < 1200) {
                                        const specialBannerGrid = block.querySelector('.special-banner__products--grid');
                                        if (specialBannerGrid) specialBannerGrid.classList.add('products-carousel');
                                        if (typeof halo.productBlockSilder === 'function') {
                                            halo.productBlockSilder(block);
                                        }
                                    }

                                    if (block.classList.contains("halo-block-unsymmetrical") && layout == 'grid' && window.innerWidth < 1200) {
                                        if (typeof halo.unsymmetricalSlider === 'function') {
                                            halo.unsymmetricalSlider(block);
                                        }
                                    }

                                    if (window.compare.show) {
                                        const compareLink = document.querySelector('[data-compare-link]');
                                        if (compareLink && halo.setLocalStorageProductForCompare) {
                                            halo.setLocalStorageProductForCompare(compareLink);
                                        }
                                    }

                                    halo.swapHoverVideoProductCard();

                                    if (window.wishlist.show && halo.setLocalStorageProductForWishlist) {
                                        halo.setLocalStorageProductForWishlist();
                                    }

                                    if (halo.checkNeedToConvertCurrency()) {
                                        const currencyEl = document.querySelector('#currencies .active');
                                        const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                                        if (currencyCode) {
                                            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                                        }
                                    }

                                    if (document.body.classList.contains('cursor-fixed__show')) {
                                        if (window.sharedFunctionsAnimation) {
                                            window.sharedFunctionsAnimation.onEnterButton();
                                            window.sharedFunctionsAnimation.onLeaveButton();
                                        }
                                    }

                                    if ($body.classList.contains('product-card-layout-08')) {
                                        halo.productCountdownCard();
                                    }
                                })
                                .catch(error => {
                                    console.error('Erro ao carregar produtos:', error);
                                });
                        } else {
                            block.classList.add('ajax-loaded');

                            if (layout == 'slider') {
                                if (typeof halo.productBlockSilder === 'function') {
                                    halo.productBlockSilder(block);
                                }
                            }

                            if (halo.checkNeedToConvertCurrency()) {
                                const currencyEl = document.querySelector('#currencies .active');
                                const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                                if (currencyCode) {
                                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                                }
                            }
                        }
                    }
                })
            }

            this.productBlock = document.querySelectorAll('[data-product-block]');

            const config = {
                rootMargin: '0px 0px 200px 0px',
            }

            this.observer = new IntersectionObserver(handler, config);
            this.productBlock.forEach(block => {
                this.observer.observe(block);
            });
        },

        handleResponse($res, productToShow, limit) {
            // $res can be array or array-like object
            if (Array.isArray($res)) {
                return $res.splice(productToShow, limit);
            } else if ($res && typeof $res.splice === 'function') {
                // Array-like object with splice method
                return $res.splice(productToShow, limit);
            } else if ($res && $res.length !== undefined) {
                // Array-like object
                return Array.from($res).splice(productToShow, limit);
            }
            return [];
        },

        loaderRecommendationsBlock: function () {
            halo.buildRecommendationBlock();
        },

        headerMasonry: function () {
            const masonryElements = document.querySelectorAll('.menu-dropdown__wrapper [data-masonry]');
            masonryElements.forEach(element => {
                if (typeof Masonry !== 'undefined') {
                    new Masonry(element, {
                        columnWidth: '.grid-sizer',
                        itemSelector: '[data-gridItem]'
                    });
                }
            });
        },

        initMenuDropdownLazyLoad: function () {
            // Atualizar lazyLoad quando menu dropdown for aberto via hover
            const menuItemsMega = document.querySelectorAll('.menu-lv-item.has-megamenu');

            menuItemsMega.forEach(function (menuItem) {
                menuItem.addEventListener('mouseenter', function () {
                    const menuDropdown = this.querySelector('.menu-dropdown');
                    if (menuDropdown && window.lazyLoadInstance) {
                        // Aguardar um pouco para o CSS fazer a transição de opacity
                        setTimeout(() => {
                            window.lazyLoadInstance.update();
                        }, 150);
                    }
                });
            });
        },

        initLiveChat: function () {
            const itemGlobe = document.querySelectorAll('.live-wrapper-icon');
            itemGlobe.forEach(icon => {
                icon.addEventListener('click', function (e) {
                    const parent = this.parentElement;
                    if (parent) parent.classList.toggle('live_help--active');
                });
            });

            $body.addEventListener('click', function (e) {
                const liveHelp = document.querySelector('.live_help');
                if (liveHelp && liveHelp.classList.contains('live_help--active')) {
                    const closestLiveHelp = e.target.closest('.live_help');
                    if (!closestLiveHelp) {
                        e.preventDefault();
                        liveHelp.classList.remove('live_help--active');
                    }
                }
            });
        },

        initHeader: function () {
            const headerAll = document.querySelectorAll('[class*="section-header"]')
            if (headerAll) {
                let index = headerAll.length + 20;
                headerAll.forEach((element) => {
                    if (element.classList.contains('section-header-mobile')) return;
                    element.setAttribute('data-index', index);
                    element.style.zIndex = index;
                    index--
                })

                const headerBasicTransparent = document.querySelector('.header-basic--transparent')
                if (headerBasicTransparent && document.body.classList.contains('template-index')) {
                    const height = headerBasicTransparent.offsetHeight,
                        navTransparent = document.querySelector('.header-navigation[class*="--transparent"]')
                    if (navTransparent) {
                        navTransparent.style.top = `${height}px`
                        navTransparent.classList.add('has-top')
                    }
                }
            }
        },

        headerLanguageCurrency: function () {
            if (!document.querySelector('.header-language_currency')) return;
            const header = document.querySelectorAll('[class*="section-header-"]')

            document.addEventListener('click', (event) => {
                const $target = event.target;
                const $headerLanguageCurrency = $target.closest('.header-language_currency');
                const languageCurrency = $headerLanguageCurrency?.querySelector('.top-language-currency');
                const dropdownCurrency = $headerLanguageCurrency?.querySelector('.dropdown-currency');
                const dropdownLanguage = $headerLanguageCurrency?.querySelector('.dropdown-language');

                if ($target.matches('.header-language_currency') || $target.closest('.header-language_currency')) {
                    if ($target.matches('.icon-languageCurrency') || $target.closest('.icon-languageCurrency')) {
                        languageCurrency?.classList.toggle('show')
                    }
                    else if (($target.matches('.top-language-currency') || $target.closest('.top-language-currency')) && !document.querySelector('.icon-languageCurrency')) {
                        languageCurrency?.classList.toggle('show')
                    }

                    if ($target.matches('.halo-top-currency') || $target.closest('.halo-top-currency')) {
                        dropdownLanguage?.classList.remove('show')
                        dropdownCurrency?.classList.toggle('show')
                    }

                    if ($target.matches('.halo-top-language') || $target.closest('.halo-top-language')) {
                        dropdownCurrency?.classList.remove('show')
                        dropdownLanguage?.classList.toggle('show')
                    }

                    if ($target.matches('.dropdown-menu .dropdown-item')) {
                        dropdownCurrency?.classList.remove('show')
                        dropdownLanguage?.classList.remove('show')
                    }
                }
                else {
                    header.forEach(element => {
                        element.querySelector('.top-language-currency')?.classList.remove('show')
                        element.querySelector('.dropdown-currency')?.classList.remove('show')
                        element.querySelector('.dropdown-language')?.classList.remove('show')
                    })
                }
            })
        },

        headerSidebarSearch: function () {
            var headerSearchPC = document.querySelector('.header-top .header__search .search_details'),
                headerSearchMB = document.querySelector('#search-form-mobile .halo-sidebar-wrapper .search_details'),
                headerwraperSearchPC = document.querySelector('.header-top .header__search'),
                headerwraperSearchMB = document.querySelector('#search-form-mobile .halo-sidebar-wrapper'),
                searchDetails = document.querySelectorAll('.search_details'),
                predictiveSearchPC = document.querySelector('.header-top .header__search predictive-search'),
                predictiveSearchMB = document.querySelector('#search-form-mobile .halo-sidebar-wrapper predictive-search');

            let finalPredictiveSearchPC = predictiveSearchPC || document.querySelector('.header-top .header__search .search_details');
            let finalPredictiveSearchMB = predictiveSearchMB || document.querySelector('#search-form-mobile .halo-sidebar-wrapper .search_details');

            if (window.innerWidth < 1025) {
                const header = document.querySelector('.header');
                if (header && header.classList.contains('header-01') && finalPredictiveSearchPC && headerwraperSearchMB) {
                    if (finalPredictiveSearchPC.parentNode !== headerwraperSearchMB) {
                        headerwraperSearchMB.appendChild(finalPredictiveSearchPC);
                    }
                }
                searchDetails.forEach(detail => detail.setAttribute('open', 'true'));

                document.querySelectorAll('[data-search-mobile]').forEach(btn => {
                    btn.addEventListener('click', (event) => {
                        event.preventDefault();
                        document.body.classList.add('open_search_mobile');

                        if ($body.classList.contains('menu_open')) {
                            $body.classList.remove('menu_open');
                        }
                    });
                });

                document.querySelectorAll('[data-search-close-sidebar]').forEach(btn => {
                    btn.addEventListener('click', (event) => {
                        event.preventDefault();
                        document.body.classList.remove('open_search_mobile');
                    });
                });
            } else {
                const header = document.querySelector('.header');
                if (header && header.classList.contains('header-01') && finalPredictiveSearchMB && headerwraperSearchPC) {
                    if (finalPredictiveSearchMB.parentNode !== headerwraperSearchPC) {
                        headerwraperSearchPC.appendChild(finalPredictiveSearchMB);
                    }
                }
                searchDetails.forEach(detail => detail.removeAttribute('open'));

                document.querySelectorAll('.search-modal__close-button').forEach(btn => {
                    btn.addEventListener('click', (event) => {
                        document.querySelectorAll('.search_details').forEach(detail => detail.removeAttribute('open'));
                        document.body.classList.remove('open_search_menu');
                    });
                });

                // Click Search Icon On Header Nav And Sticky Menu
                document.querySelectorAll('[data-search-menu]').forEach(btn => {
                    btn.addEventListener('click', (event) => {
                        event.preventDefault();
                        document.body.classList.add('open_search_menu');
                    });
                });
            }
        },

        headerStickySearchForm: function () {
            var iconSearchSlt = '[data-search-sticky-form]';
            var iconSearchMenu = '[data-search-menu-sticky-form] .icon-search';
            var iconSearchMenuCustom = '[data-search-menu-sticky-form] .icon-search-custom';

            if (window.innerWidth > 1025) {
                // Remove previous listeners by cloning and replacing elements
                const toggleSearchHandler = (event) => {
                    const target = event.target.closest(iconSearchSlt);
                    if (!target) return;
                    event.preventDefault();
                    event.stopPropagation();
                    document.body.classList.add('sticky-search-open');
                    const searchDetails = document.querySelector('.search_details');
                    if (searchDetails) searchDetails.setAttribute('open', 'true');
                };

                const hideSearchHandler = (event) => {
                    const formSearch = document.querySelector('.search-modal__form');
                    const quickSearch = document.querySelector('.quickSearchResultsWrap');
                    const target = event.target;

                    if (document.body.classList.contains('sticky-search-open')) {
                        const isInFormSearch = formSearch && formSearch.contains(target);
                        const isInQuickSearch = quickSearch && quickSearch.contains(target);
                        const isSearchContent = target.classList.contains('search-modal__content') || target.closest('.search-modal__content');

                        if (!isInFormSearch && !isInQuickSearch && !isSearchContent) {
                            document.body.classList.remove('sticky-search-open');
                            document.querySelectorAll('[class*="section-header-"]').forEach(el => {
                                el.classList.remove('sticky-search-menu-open');
                            });
                            const searchDetails = document.querySelector('.search_details');
                            if (searchDetails) searchDetails.removeAttribute('open');
                        }
                    }
                };

                // Click Search Icon On Header Nav And Sticky Menu
                const toggleSearchMenuHandler = (event) => {
                    const target = event.target.closest(iconSearchMenu);
                    const summaryElement = event.target.closest('[data-search-menu-sticky-form]');

                    // Verificar se o clique foi no ícone ou no summary
                    if (!target && !summaryElement) return;

                    event.preventDefault();
                    event.stopPropagation();

                    const elementToUse = target || summaryElement;
                    const sectionHeader = elementToUse.closest('[class*="section-header-"]');
                    const sectionNav = elementToUse.closest('.section-header-navigation');

                    if (sectionHeader) sectionHeader.classList.add('sticky-search-menu-open');
                    if (sectionNav) sectionNav.style.zIndex = '101';

                    // Encontrar o search_details mais próximo do elemento clicado
                    // Priorizar o que está dentro do mesmo contexto do elemento clicado
                    let searchDetails = null;
                    if (summaryElement) {
                        searchDetails = summaryElement.closest('.search_details');
                    }
                    if (!searchDetails) {
                        // Se não encontrou, procurar no contexto do header navigation
                        const headerNav = elementToUse.closest('.header-navigation');
                        if (headerNav) {
                            searchDetails = headerNav.querySelector('.search_details');
                        }
                    }
                    if (!searchDetails) {
                        // Fallback: procurar globalmente
                        searchDetails = document.querySelector('.search_details');
                    }

                    if (searchDetails) {
                        searchDetails.setAttribute('open', 'true');
                        // Garantir que o input receba foco
                        setTimeout(() => {
                            const searchInput = searchDetails.querySelector('input[type="search"]');
                            if (searchInput) {
                                searchInput.focus();
                            }
                        }, 100);
                    }
                };

                // Click Search Icon On Header Hamburger - Search Dropdown Style Layout Custom
                const toggleSearchMenuCustomHandler = (event) => {
                    const target = event.target.closest(iconSearchMenuCustom);
                    if (!target) return;
                    const sectionHeader = target.closest('[class*="section-header-"]');
                    if (sectionHeader) sectionHeader.classList.add('sticky-search-menu-custom-open');
                };

                const hideSearchStickyHandler = (event) => {
                    const formSearch = document.querySelector('.header-navigation .search-modal__form');
                    const quickSearch = document.querySelector('.header-navigation .quickSearchResultsWrap');
                    const target = event.target;
                    const sectionHeaders = document.querySelectorAll('[class*="section-header-"]');

                    // Check if any section header has sticky-search-menu-open class
                    let hasStickyMenuOpen = false;
                    sectionHeaders.forEach(el => {
                        if (el.classList.contains('sticky-search-menu-open')) {
                            hasStickyMenuOpen = true;
                        }
                    });

                    if (hasStickyMenuOpen) {
                        const isInFormSearch = formSearch && formSearch.contains(target);
                        const isInQuickSearch = quickSearch && quickSearch.contains(target);
                        const isSearchContent = target.classList.contains('search-modal__content') || target.closest('.search-modal__content');

                        if (!isInFormSearch && !isInQuickSearch && !isSearchContent) {
                            const iconSearchMenuEl = document.querySelector(iconSearchMenu);
                            const header = iconSearchMenuEl ? iconSearchMenuEl.closest('.section-header-navigation') : null;
                            const index = header ? (header.dataset.index || header.getAttribute('data-index') || '') : '';

                            sectionHeaders.forEach(el => {
                                el.classList.remove('sticky-search-menu-open');
                            });

                            if (header && index) {
                                header.style.zIndex = index;
                            }

                            const searchDetails = document.querySelector('.header-navigation .search_details');
                            if (searchDetails) searchDetails.removeAttribute('open');

                            if (quickSearch && quickSearch.classList.contains('is-show')) {
                                quickSearch.classList.remove('is-show');
                                quickSearch.classList.add('hidden');
                            }
                        }
                    }

                    if (!target.closest('.search-modal__content')) {
                        document.body.classList.remove('open_search_menu');
                        sectionHeaders.forEach(el => {
                            el.classList.remove('sticky-search-menu-custom-open');
                        });
                    }
                };

                // Add event listeners
                document.querySelectorAll(iconSearchSlt).forEach(el => {
                    el.addEventListener('click', toggleSearchHandler);
                });
                document.addEventListener('click', hideSearchHandler);
                document.querySelectorAll(iconSearchMenu).forEach(el => {
                    el.addEventListener('click', toggleSearchMenuHandler);
                });
                // Adicionar listener também no próprio summary para garantir que funcione
                document.querySelectorAll('[data-search-menu-sticky-form]').forEach(el => {
                    el.addEventListener('click', toggleSearchMenuHandler);
                });
                document.querySelectorAll(iconSearchMenuCustom).forEach(el => {
                    el.addEventListener('click', toggleSearchMenuCustomHandler);
                });
                document.addEventListener('click', hideSearchStickyHandler);
            }
        },

        // All Menu Mobile functions moved to menu-mobile.js module
        // menuSidebarMobile, menuSidebarMobileToggle, initMultiTab, initMobileMenuDefault, initMultiTabMobile
        // See: assets/menu-mobile.js

        // menuSidebarMobileToggle moved to menu-mobile.js

        setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        },

        // initMultiTab moved to menu-mobile.js

        // initMobileMenuDefault moved to menu-mobile.js

        // initMultiTabMobile moved to menu-mobile.js

        initMenu: function (url) {
            const header = document.querySelector('.header');
            if (!header || !header.classList.contains('header-04')) {
                fetch(url)
                    .then(response => response.text())
                    .then(text => {
                        const html = document.createElement('div');
                        html.innerHTML = text;
                        const navigation = html.querySelector('#HeaderNavigation');
                        if (navigation && navigation.innerHTML.trim().length) {
                            document.querySelector('#HeaderNavigation').innerHTML = navigation.innerHTML;
                        }
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }
        },

        // All Product Tabs functions moved to product-tabs.js module
        // clickedActiveProductTabs, doAjaxProductTabs
        // See: assets/product-tabs.js

        // doAjaxProductTabs moved to product-tabs.js
        lookbookCarousel: function () {
            // Lookbook carousel is now handled by lookbook-swiper.js module
            // This function is kept for backward compatibility but delegates to the Swiper module
            const lookbookCarousels = document.querySelectorAll('.lookbook-carousel');

            if (lookbookCarousels.length > 0) {
                // Initialize Swiper if not already initialized
                if (typeof window.initLookbookCarousel === 'function') {
                    window.initLookbookCarousel();
                }

                // Handle counter number if enabled
                lookbookCarousels.forEach(lookbookCarousel => {
                    if (lookbookCarousel.classList.contains('enable_counter_number')) {
                        const lookbookBanner = lookbookCarousel.closest('.special-banner__item--lookbook_banner');
                        if (lookbookBanner) {
                            const counterNumber = lookbookBanner.querySelector('.products-counter-number');
                            const swiperNext = lookbookCarousel.querySelector('.swiper-button-next');
                            if (counterNumber && swiperNext) {
                                swiperNext.appendChild(counterNumber);
                            }

                            // Update counter on slide change (Swiper)
                            if (typeof Swiper !== 'undefined') {
                                const swiperInstance = lookbookCarousel.swiper;
                                if (swiperInstance) {
                                    swiperInstance.on('slideChange', () => {
                                        const countImage = lookbookCarousel.querySelector("#count-image");
                                        if (countImage) {
                                            countImage.textContent = swiperInstance.activeIndex + 1;
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }

            if (document.body.classList.contains('cursor-fixed__show')) {
                window.sharedFunctionsAnimation.onEnterButton();
                window.sharedFunctionsAnimation.onLeaveButton();
            }
        },
        productBlockSilder: function (wrapper) {
            // Convert wrapper from jQuery to DOM element if needed
            const wrapperEl = wrapper instanceof Element ? wrapper : (wrapper && wrapper[0] ? wrapper[0] : wrapper);
            if (!wrapperEl) return;

            var productGrid = wrapperEl.querySelector('.products-carousel');
            if (!productGrid) return;

            // Use Swiper module
            if (typeof window.initProductBlockSlider === 'function') {
                const swiper = window.initProductBlockSlider(wrapperEl);
                if (swiper) {
                    // Handle additional features
                    this.handleProductBlockSliderFeatures(wrapperEl, productGrid, swiper);
                }
            }
        },

        handleProductBlockSliderFeatures: function (wrapperEl, productGrid, swiper) {
            // Handle features that were specific to Slick version
            var itemToShow = productGrid.dataset.itemToShow,
                isProductCard06 = document.body.classList.contains('product-card-layout-06'),
                swatchLabel = productGrid.querySelectorAll('.swatch .swatch-label');

            // Handle product card 06 padding
            if (isProductCard06) {
                swiper.on('init', () => {
                    const cardAction = productGrid.querySelector('.product .card-action');
                    const selectOptionsHeight = cardAction ? cardAction.offsetHeight : 0;
                    const swiperWrapper = productGrid.querySelector('.swiper-wrapper');
                    if (swiperWrapper) {
                        swiperWrapper.style.paddingBottom = selectOptionsHeight + 'px';
                    }
                    productGrid.setAttribute('data-slider-padding-bottom', selectOptionsHeight);
                });
            }

            // Handle progress bar
            if (productGrid.classList.contains('enable_progress_bar')) {
                var progressBar = wrapperEl.querySelector('.scrollbar-thumb');
                swiper.on('init', () => {
                    if (progressBar && swiper.slides.length > 0) {
                        var percent = ((swiper.activeIndex / (swiper.slides.length - (parseInt(itemToShow) || 1))) * 100) + '%';
                        progressBar.style.setProperty('--percent', percent);
                    }
                });
                swiper.on('slideChange', () => {
                    if (progressBar && swiper.slides.length > 0) {
                        var percent = ((swiper.activeIndex / (swiper.slides.length - (parseInt(itemToShow) || 1))) * 100) + '%';
                        progressBar.style.setProperty('--percent', percent);
                    }
                });
            }

            // Handle counter number
            if (productGrid.classList.contains('enable_counter_number')) {
                const swiperNext = productGrid.querySelector('.swiper-button-next');
                const parentBlock = productGrid.closest('.halo-block, .special-banner__product, .cust-prod-widget__product');
                const counterNumber = parentBlock ? parentBlock.querySelector('.products-counter-number') : null;
                if (swiperNext && counterNumber) swiperNext.appendChild(counterNumber);

                swiper.on('slideChange', () => {
                    var displayCount = swiper.activeIndex + (parseInt(itemToShow) || 1);
                    var totalItems = parseInt(wrapperEl.dataset.limit || 0);
                    if (displayCount > totalItems) {
                        displayCount = totalItems;
                    }
                    const countImage = productGrid.querySelector("#count-image");
                    if (countImage) countImage.textContent = displayCount;
                });
            }

            // Handle swatch label height adjustment
            if (swatchLabel.length > 0) {
                function getMaxHeight() {
                    var maxHeight = 0;
                    const swiperSlides = productGrid.querySelectorAll('.swiper-slide');
                    swiperSlides.forEach((slide) => {
                        const slideHeight = slide.offsetHeight + parseInt(window.getComputedStyle(slide).marginTop) + parseInt(window.getComputedStyle(slide).marginBottom);
                        if (slideHeight > maxHeight) {
                            maxHeight = slideHeight;
                        }
                    });
                    return maxHeight;
                }

                productGrid.addEventListener('click', function (e) {
                    if (e.target.closest('.swatch .swatch-label')) {
                        setTimeout(() => {
                            var maxHeight = getMaxHeight();
                            const swiperWrapper = productGrid.querySelector(".swiper-wrapper");
                            if (swiperWrapper) {
                                swiperWrapper.style.height = maxHeight + 'px';
                                swiperWrapper.style.transition = "500ms ease";
                            }
                            swiper.update();
                        }, 50);
                    }
                });
            }

            if (document.body.classList.contains('cursor-fixed__show')) {
                window.sharedFunctionsAnimation.onEnterButton();
                window.sharedFunctionsAnimation.onLeaveButton();
            }
        },

        // All Product Block Infinite Scroll functions moved to product-block-infinite.js module
        // productBlockInfiniteScroll, doProductBlockInfiniteScroll, handleResponse
        // See: assets/product-block-infinite.js

        // doProductBlockInfiniteScroll moved to product-block-infinite.js

        // All Mega Menu Product Block functions moved to mega-menu-product.js module
        // doBeforeMegaMenuProductBlock, renderMegaMenuProductBlock, productMenuSlider
        // See: assets/mega-menu-product.js


        // renderMegaMenuProductBlock moved to mega-menu-product.js

        // productMenuSlider moved to mega-menu-product.js

        buildRecommendationBlock: function () {
            if (document.querySelector('[data-recommendations-block]') == null) return;

            var $this = document.querySelector('[data-recommendations-block]'),
                layout = $this.dataset.layout;
            swipe = $this.dataset.swipe;

            const config = {
                threshold: 0.25,
            }

            const handleIntersection = (entries, observer) => {
                const recommendationsContainer = $this.querySelector('.wrapper-container');
                if (!entries[0].isIntersecting) return;
                if ($this.innerHTML.trim() != '' && !recommendationsContainer.classList.contains('product-recommendations-loading') && !recommendationsContainer.classList.contains('has-product')) return;
                recommendationsContainer.classList.add('has-product');

                fetch($this.dataset.url)
                    .then(response => response.text())
                    .then(text => {
                        const html = document.createElement('div');
                        html.innerHTML = text;
                        const recommendations = html.querySelector('[data-recommendations-block]');
                        if (recommendations && recommendations.innerHTML.trim().length) {
                            $this.innerHTML = recommendations.innerHTML;

                            var productItems = $this.querySelectorAll('.product-item');
                            if (productItems.length === 0) {
                                $this.remove();
                                return;
                            }

                            var firstProduct = productItems[0];
                            var firstProductData = firstProduct.getAttribute('data-json-product');
                            if (!firstProductData) {
                                $this.remove();
                                return;
                            }

                            if (layout == 'slider') {
                                if (typeof halo.productBlockSilder === 'function') {
                                    halo.productBlockSilder($this);
                                }
                            }

                            productItems.forEach(async (rawProduct) => {
                                var productId = rawProduct.getAttribute('data-product-id');
                                var productJsonStr = rawProduct.getAttribute('data-json-product');
                                if (!productJsonStr) return;

                                var productJson = JSON.parse(productJsonStr);
                                var handle = productJson.handle;

                                try {
                                    const response = await fetch(window.routes.root + '/products/' + handle + '?view=ajax_variant_quantity');
                                    if (!response.ok) {
                                        const errorData = await response.json();
                                        if (typeof halo.showWarning === 'function') {
                                            halo.showWarning(errorData.description || 'Erro ao carregar quantidade');
                                        }
                                        return;
                                    }
                                    const data = await response.text();
                                    const element = new DOMParser().parseFromString(data, 'text/html');
                                    const quantityEl = element.querySelector(`[data-quantity-product-id="${productId}"]`);
                                    if (quantityEl) {
                                        const quantityInfo = JSON.parse(quantityEl.innerHTML);
                                        window[`quick_view_inven_array_${productId}`] = quantityInfo;
                                    }
                                } catch (error) {
                                    console.error('Erro ao carregar quantidade do produto:', error);
                                    if (typeof halo.showWarning === 'function') {
                                        halo.showWarning('Erro ao carregar quantidade');
                                    }
                                }
                            });

                            const loadingImages = $this.querySelectorAll('.media--loading-effect img');
                            this.observeImageLazyloaded(loadingImages);

                            if (window.compare.show) {
                                const compareLink = document.querySelector('[data-compare-link]');
                                if (compareLink && halo.setLocalStorageProductForCompare) {
                                    halo.setLocalStorageProductForCompare(compareLink);
                                }
                            }

                            if (window.wishlist.show && halo.setLocalStorageProductForWishlist) {
                                halo.setLocalStorageProductForWishlist();
                            }

                            if (document.body.classList.contains('cursor-fixed__show')) {
                                if (window.sharedFunctionsAnimation) {
                                    window.sharedFunctionsAnimation.onEnterButton();
                                    window.sharedFunctionsAnimation.onLeaveButton();
                                }
                            }

                            if ($body.classList.contains('product-card-layout-08')) {
                                halo.productCountdownCard();
                            }

                            this.calculateTranslateYHeight()
                        }
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }

            new IntersectionObserver(handleIntersection.bind($this), ({}, config)).observe($this);
        },

        // All Video Popup functions moved to video-popup.js module
        // initVideoPopup, swapHoverVideoProductCard
        // See: assets/video-popup.js

        // swapHoverVideoProductCard moved to video-popup.js

        initGlobalCheckbox: function () {
            document.addEventListener('change', (event) => {
                if (event.target.classList.contains('global-checkbox--input')) {
                    const targetId = event.target.getAttribute('data-target');
                    const targetElement = targetId ? document.querySelector(targetId) : null;
                    if (targetElement) {
                        if (event.target.checked) {
                            targetElement.removeAttribute('disabled');
                        } else {
                            targetElement.setAttribute('disabled', 'disabled');
                        }
                    }
                }
            });

            document.addEventListener('click', (event) => {
                if (event.target.closest('[data-term-condition]')) {
                    event.preventDefault();
                    event.stopPropagation();
                    document.body.classList.add('term-condition-show');
                }

                if (event.target.closest('[data-close-term-condition-popup]')) {
                    event.preventDefault();
                    event.stopPropagation();
                    document.body.classList.remove('term-condition-show');
                }
            });

            document.addEventListener('click', (event) => {
                setTimeout(() => {
                    if (document.body.classList.contains('cart-sidebar-show')) {
                        if (!event.target.closest('[data-term-condition-popup]')) {
                            document.body.classList.remove('term-condition-show');
                        }
                    }
                    if (document.body.classList.contains('term-condition-show')) {
                        if (!event.target.closest('[data-term-condition-popup]')) {
                            document.body.classList.remove('term-condition-show');
                        }
                    }
                }, 10);
            });
        },

        initColorSwatch: function () {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', function () {
                    document.querySelectorAll('.card .swatch-label.is-active').forEach(label => {
                        label.click();
                    });
                });
            } else {
                document.querySelectorAll('.card .swatch-label.is-active').forEach(label => {
                    label.click();
                });
            }

            document.addEventListener('click', (event) => {
                const target = event.target.closest('.card .swatch-label');
                if (!target) return;

                const title = (target.getAttribute('title') || '').replace(/^\s+|\s+$/g, '');
                const product = target.closest('.product-item');
                if (!product) return;

                const productJsonData = product.dataset.jsonProduct || product.getAttribute('data-json-product');
                const productJson = productJsonData ? JSON.parse(productJsonData) : null;
                const productTitle = product.querySelector('.card-title');
                const productAction = product.querySelector('[data-btn-addtocart]');
                const productAction2 = product.querySelector('.card-product [data-btn-addtocart]');
                const variantId = target.dataset.variantId || target.getAttribute('data-variant-id');
                const productLink = product.querySelector('a');
                const productHref = productLink ? productLink.getAttribute('href') : '';
                const oneOption = target.dataset.withOneOption || target.getAttribute('data-with-one-option');
                const newImage = target.dataset.variantImg || target.getAttribute('data-variant-img');
                let mediaList = [];



                const $iconAddtocart = '<svg class="icon icon-cart" viewBox="0 0 286.74 356.73">\
                  <g data-name="Layer 1">\
                    <path d="m286.33,277.03l-.17-3.91c-.81-18.73-1.83-37.7-2.83-56.05l-.79-14.51c-.43-8.13-.9-16.26-1.37-24.4l-.24-4.18c-.84-14.79-1.71-30.08-2.35-45.1-.93-21.43-14.62-35.84-34.07-35.86h-20.65c-.42-20.33-5.78-38.81-15.94-54.94C189.14,8.27,157.22-5.8,126.6,2.23c-27.48,7.21-46.98,26.7-57.96,57.94-3.5,9.98-5.33,20.76-5.56,32.86h-9.52c-4.59,0-9.05-.01-12.39,0-16.64.12-30.01,12.35-31.79,29.06-1.42,13.39-2.1,27.29-2.7,39.55-.24,4.97-.5,9.95-.77,14.91-1.22,21.28-2.24,39.94-3.13,57.07-.29,5.45-.6,10.9-.92,16.36l-.02.3c-.82,13.9-1.67,28.28-1.82,42.5-.18,16.51,5.81,32.31,16.86,44.5,11.15,12.29,26.39,19.35,41.81,19.37,22.45.05,49.37.08,82.32.08s60.43-.02,87.24-.08c28.28-.04,53.63-23.49,57.72-53.39,1.19-8.74.78-17.61.37-26.23ZM63.13,130.98c.09,7.97,4.99,13.59,11.92,13.67h.12c6.97,0,11.9-5.57,11.99-13.53.04-3.2.04-6.33.04-9.63v-2.53s112.59,0,112.59,0v10.76c0,4.95,1.26,8.81,3.76,11.51,2.07,2.2,4.95,3.4,8.33,3.45h.11c5.72-.08,11.83-4.11,11.85-15.16v-10.77c.83-.01,1.68-.03,2.55-.04h.62c7.1-.1,15.15-.2,20.48.19,3.7.28,6.59,4.2,6.87,9.32.68,12.51,1.41,26.28,2.28,43.33l.1,2.01c.67,12.86,1.34,25.72,2.04,38.59.31,5.58.6,11.17.87,16.76.91,17.56,1.84,35.72,3.19,53.79,1.49,20.32-4.18,34.05-17.84,43.2-5.16,3.45-10.88,5.2-17.01,5.2h-15.06c-45.58.05-104.28.1-154.01-.02-9.16-.02-18.22-4.27-24.85-11.68-6.63-7.39-10.18-16.92-10-26.83.28-14.29,1.14-29.09,1.9-42.15.31-5.37.62-10.74.91-16.1.54-10.41,1.12-20.81,1.69-31.22l.07-1.28c.21-3.92.43-7.85.65-11.77.22-3.94.44-7.88.65-11.82.15-2.9.3-5.8.45-8.7.15-2.9.3-5.79.45-8.7.51-10.04,1.11-21.71,1.81-33.09.33-5.43,3.75-8.98,8.7-9.05,2.69-.04,6.15-.06,10-.06h11.79v3.83c0,1.68-.01,3.34,0,5h-.06l.04,3.54Zm24.05-38.1c.01-6.61,1.06-13.49,3.19-20.92,4.62-16.13,13.13-28.65,25.29-37.21,18.23-12.86,40.54-12.15,58.21,1.84,15.57,12.32,25.91,35.07,25.84,56.29h-112.53Z"></path>\
                  </g>\
                </svg>';

                const swatch = target.closest('.swatch');
                if (swatch) {
                    swatch.querySelectorAll('.swatch-label').forEach(label => label.classList.remove('is-active'));
                }
                target.classList.add('is-active');

                if (productTitle) {
                    const changeTitleEl = productTitle.querySelector('[data-change-title]');
                    if (changeTitleEl) {
                        if (document.body.classList.contains('style_2_text_color_varriant')) {
                            changeTitleEl.textContent = title;
                        } else {
                            changeTitleEl.textContent = ' - ' + title;
                        }
                    } else {
                        productTitle.classList.add('card-title-change');
                        const span = document.createElement('span');
                        span.setAttribute('data-change-title', '');
                        if (document.body.classList.contains('style_2_text_color_varriant')) {
                            span.textContent = title;
                        } else {
                            span.textContent = ' - ' + title;
                        }
                        productTitle.appendChild(span);
                    }
                }

                if (!productJson || !productJson.variants) return;

                const selectedVariant = productJson.variants.find(variant => variant.id == variantId);
                if (!selectedVariant) return;

                const priceEl = product.querySelector('.price');
                if (selectedVariant.compare_at_price > selectedVariant.price) {
                    if (priceEl) priceEl.classList.add('price--on-sale');
                    const priceRegular = product.querySelector('.price__sale .price-item--regular');
                    const priceSale = product.querySelector('.price__sale .price-item--sale');
                    if (priceRegular) priceRegular.innerHTML = Shopify.formatMoney(selectedVariant.compare_at_price, window.money_format);
                    if (priceSale) priceSale.innerHTML = Shopify.formatMoney(selectedVariant.price, window.money_format);
                    const labelSale = `(-${Math.round((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price)}%)`;
                    const labelSaleEl = product.querySelector('.price__label_sale .label_sale');
                    if (labelSaleEl) labelSaleEl.innerHTML = labelSale;
                } else {
                    const priceRegularEl = product.querySelector('.price__regular .price-item');
                    if (priceRegularEl) priceRegularEl.innerHTML = Shopify.formatMoney(selectedVariant.price, window.money_format);

                    if (selectedVariant.compare_at_price == null) {
                        if (priceEl) priceEl.classList.remove('price--on-sale');
                        const priceSaleRegular = product.querySelector('.price__sale .price-item--regular');
                        if (priceSaleRegular) priceSaleRegular.innerHTML = '';
                    }
                }

                const productLinks = product.querySelectorAll('a:not(.single-action):not(.number-showmore):not(.vendor-text)');
                productLinks.forEach(link => {
                    link.setAttribute('href', productHref.split('?variant=')[0] + '?variant=' + variantId);
                });

                if (oneOption != undefined && oneOption !== null) {
                    const quantity = parseInt(target.dataset.quantity || target.getAttribute('data-quantity') || '0');

                    const idInput = product.querySelector('[name="id"]');
                    if (idInput) idInput.value = oneOption;

                    if (productAction) {
                        if (quantity > 0) {
                            if (window.notify_me.show) {
                                productAction.classList.remove('is-notify-me');
                                productAction.classList.add('is-visible');
                            } else {
                                productAction.classList.remove('is-soldout');
                                productAction.classList.add('is-visible');
                            }
                        } else {
                            if (window.notify_me.show) {
                                productAction.classList.remove('is-visible');
                                productAction.classList.add('is-notify-me');
                            } else {
                                productAction.classList.remove('is-visible');
                                productAction.classList.add('is-soldout');
                            }
                        }

                        if (productAction.classList.contains('is-soldout') || productAction.classList.contains('is-notify-me')) {
                            if (productAction.classList.contains('is-notify-me')) {
                                if (document.body.classList.contains('product-card-layout-08') && productAction2) {
                                    productAction2.innerHTML = $iconAddtocart;
                                    productAction2.disabled = false;
                                } else {
                                    productAction.textContent = window.notify_me.button;
                                }
                            } else {
                                if (document.body.classList.contains('product-card-layout-08') && productAction2) {
                                    productAction2.innerHTML = $iconAddtocart;
                                    productAction2.disabled = true;
                                } else {
                                    productAction.textContent = window.variantStrings.soldOut;
                                    productAction.disabled = true;
                                }
                            }
                        } else {
                            if (document.body.classList.contains('product-card-layout-08') && productAction2) {
                                productAction2.innerHTML = $iconAddtocart;
                                productAction2.disabled = false;
                            } else {
                                productAction.textContent = window.variantStrings.addToCart;
                                productAction.disabled = false;
                            }
                        }
                    }
                } else {
                    if (productJson) {
                        if (window.quick_shop.show) {
                            if (halo.checkStatusSwatchQuickShop) {
                                halo.checkStatusSwatchQuickShop(product, productJson);
                            }
                        }
                    }

                    const swatchElement = product.querySelector('.swatch-element[data-value="' + title + '"]');
                    if (swatchElement) {
                        const singleLabel = swatchElement.querySelector('.single-label');
                        if (singleLabel) singleLabel.click();
                    }
                }

                if (productJson && productJson.media) {
                    mediaList = productJson.media.filter((element) => {
                        return element.alt === title;
                    });
                }

                if (mediaList.length > 0) {
                    const length = mediaList.length > 1 ? 2 : mediaList.length;
                    const cardMediaImgs = product.querySelectorAll('.card-media img');
                    for (let i = 0; i < length && i < cardMediaImgs.length; i++) {
                        cardMediaImgs[i].setAttribute('srcset', mediaList[i].src);
                    }
                } else {
                    if (newImage) {
                        const firstImg = product.querySelector('.card-media img:nth-child(1)');
                        if (firstImg) {
                            firstImg.setAttribute('srcset', newImage);
                            firstImg.setAttribute('data-srcset', newImage);
                        }
                    }
                }

                // halo.checkPreOrderOfVariant(selectedVariant, productAction, productJson)
                if (halo.checkNeedToConvertCurrency()) {
                    const currencyEl = document.querySelector('#currencies .active');
                    const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                    if (currencyCode) {
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }
                }
            });

            document.addEventListener('click', (event) => {
                const target = event.target.closest('.item-swatch-more .number-showmore');
                if (!target) return;

                const swatch = target.closest('.swatch');
                if (swatch) {
                    if (swatch.classList.contains('show--more')) {
                        swatch.classList.remove('show--more');
                        const span = target.querySelector('span');
                        if (span) span.textContent = '+';
                    } else {
                        swatch.classList.add('show--more');
                        const span = target.querySelector('span');
                        if (span) span.textContent = '-';
                    }
                }
            });
        },

        checkPreOrderOfVariant: function (selectedVariant, productAction, productJson) {
            // Check if variant is allowed to sale when out of stock
            const variantId = selectedVariant.id
            const updatePreOrderText = (productAction, selectedVariant, inventoryQuantity) => {
                if (!productAction) return;
                const product = productAction.closest('.product-item');
                const hasQuickShopPanel = product ? product.querySelector('[data-quickshop-popup]') !== null : false;

                if (selectedVariant.inventory_management == null) {
                    productAction.textContent = hasQuickShopPanel ? window.variantStrings.add : window.variantStrings.addToCart;
                    productAction.disabled = false;
                    productAction.classList.remove('is-notify-me');
                    productAction.classList.add('button--pre-untrack');
                }
                else if (selectedVariant.available && inventoryQuantity <= 0) {
                    productAction.textContent = window.variantStrings.preOrder;
                    productAction.disabled = false;
                    productAction.classList.remove('is-notify-me');
                    productAction.classList.add('button--pre-untrack');
                } else {
                    productAction.classList.remove('button--pre-untrack');
                    if (inventoryQuantity > 0) {
                        if (window.notify_me.show) {
                            productAction.classList.remove('is-notify-me');
                            productAction.classList.add('is-visible');
                        } else {
                            productAction.classList.remove('is-soldout');
                            productAction.classList.add('is-visible');
                        }
                    } else {
                        if (window.notify_me.show) {
                            productAction.classList.remove('is-visible');
                            productAction.classList.add('is-notify-me');
                            productAction.disabled = false;
                        } else {
                            productAction.classList.remove('is-visible');
                            productAction.classList.add('is-soldout');
                            productAction.disabled = true;
                        }
                    }

                    if (productAction.classList.contains('is-soldout') || productAction.classList.contains('is-notify-me')) {
                        if (productAction.classList.contains('is-notify-me')) {
                            productAction.textContent = window.notify_me.button;
                            productAction.disabled = false;
                            productAction.classList.remove('btn-unavailable');
                        } else {
                            productAction.textContent = window.variantStrings.soldOut;
                            productAction.disabled = true;
                        }
                    } else {
                        productAction.textContent = hasQuickShopPanel ? window.variantStrings.add : window.variantStrings.addToCart;
                        productAction.disabled = false;
                    }
                }
            }

            const variantsQuantityInvenText = `quick_view_inven_array_${productJson.id}`
            var arrayInVarName = variantsQuantityInvenText,
                inven_array = window[arrayInVarName];

            if (inven_array != undefined) {
                var inven_num = inven_array[variantId],
                    inventoryQuantity = parseInt(inven_num);
                updatePreOrderText(productAction, selectedVariant, inventoryQuantity)
            } else {
                fetch(window.routes.root + '/products/' + productJson.handle + '?view=ajax_quick_shop_data', {
                    method: 'GET'
                })
                    .then(response => response.text())
                    .then(data => {
                        window[variantsQuantityInvenText] = JSON.parse(data.split('=')[1]);
                        var inven_num = window[variantsQuantityInvenText][variantId];
                        var inventoryQuantity = parseInt(inven_num);
                        updatePreOrderText(productAction, selectedVariant, inventoryQuantity);
                    })
                    .catch(error => {
                        try {
                            const errorData = JSON.parse(error.responseText || '{}');
                            halo.showWarning(errorData.description || 'Error loading inventory data');
                        } catch (e) {
                            halo.showWarning('Error loading inventory data');
                        }
                    });
            }
        },

        // All Quick Shop functions moved to quick-shop.js module
        // initQuickShop, appendToListViewModal, changeSwatchQuickShop, checkStatusSwatchQuickShop,
        // initAddToCartQuickShop, updateContentQuickshopOption3, updateContentQuickBulk,
        // appendProductQuickShopOption2, initQuickShopProductList, updateContentQuickShop
        // See: assets/quick-shop.js

        // appendToListViewModal, changeSwatchQuickShop moved to quick-shop.js

        // checkStatusSwatchQuickShop moved to quick-shop.js

        // initAddToCartQuickShop moved to quick-shop.js

        // All Add to Cart functions moved to add-to-cart.js module
        // initAddToCart, actionAddToCart, actionAddToCart2, checkSufficientStock
        // See: assets/add-to-cart.js

        // actionAddToCart, actionAddToCart2 moved to add-to-cart.js

        // checkSufficientStock moved to add-to-cart.js

        // updateContentQuickshopOption3 moved to quick-shop.js

        // updateContentQuickBulk moved to quick-shop.js

        // appendProductQuickShopOption2 moved to quick-shop.js

        isRunningInIframe: function () {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },

        redirectTo: function (url) {
            if (halo.isRunningInIframe() && !window.iframeSdk) {
                window.top.location = url;
            } else {
                window.location = url;
            }
        },

        // Cart functions moved to cart-sidebar.js module
        // initQuickCart, initEventQuickCart, productCollectionCartSlider, updatePopupCart,
        // initSidebarCart, updateSidebarCart, dispatchChangeForShippingMessage, updateGiftWrapper,
        // removeItemQuickCart, updateCart, updateQuantityItemQuickCart, editQuickCart,
        // addMoreItemEditCart, updateClonedProductAttributes, addAllItemCartEdit
        // See: assets/cart-sidebar.js

        // updatePopupCart moved to cart-sidebar.js

        // All cart functions moved to cart-sidebar.js module
        // See: assets/cart-sidebar.js

        // All Notify In Stock functions moved to notify-in-stock.js module
        // initNotifyInStock, notifyInStockPopup
        // See: assets/notify-in-stock.js

        // notifyInStockPopup moved to notify-in-stock.js

        // All Ask An Expert functions moved to ask-an-expert.js module
        // initAskAnExpert
        // See: assets/ask-an-expert.js

        // All Form Message functions moved to form-message.js module
        // resetForm, formMessage, changeStateforContactForm
        // See: assets/form-message.js

        // formMessage moved to form-message.js

        // changeStateforContactForm moved to form-message.js

        // All compare functions moved to compare-product.js module
        // See: assets/compare-product.js

        // All Product View functions moved to product-view.js module
        // initProductView, productImageGallery, productVideoGallery, initVariantImageGroup,
        // initYoutubeCarousel, productSizeChart, productLastSoldOut, productCustomerViewing,
        // productCountdown, productCustomCursor
        // See: assets/product-view.js

        // All quick-view functions moved to quick-view.js module
        // See: assets/quick-view.js

        // productImageGallery moved to product-view.js

        // productVideoGallery moved to product-view.js

        // initVariantImageGroup moved to product-view.js

        // initYoutubeCarousel moved to product-view.js

        // productSizeChart moved to product-view.js

        // productLastSoldOut moved to product-view.js

        // productCustomerViewing moved to product-view.js

        // productCountdown moved to product-view.js

        // productCustomCursor moved to product-view.js

        // All wishlist functions moved to wishlist.js module
        // See: assets/wishlist.js

        // calculateCard06Padding moved to wishlist.js module
        // See: assets/wishlist.js

        // setProductForWishlist and setLocalStorageProductForWishlist moved to wishlist.js

        // All Countdown functions moved to countdown.js module
        // initCountdown, collectionCountdown
        // See: assets/countdown.js

        // collectionCountdown moved to countdown.js

        handleScrollDown: function () {
            const iconScrollDownElements = document.querySelectorAll('[data-scroll-down]');

            if (iconScrollDownElements.length) {
                iconScrollDownElements.forEach(function (element) {
                    const nextSection = element.closest('.shopify-section')?.nextElementSibling;
                    if (nextSection && nextSection.classList.contains('shopify-section')) {
                        const targetId = nextSection.id;
                        if (targetId) {
                            element.setAttribute('href', '#' + targetId);
                        }
                    }

                    element.addEventListener('click', function (e) {
                        e.preventDefault();
                        const href = this.getAttribute('href');
                        if (href && href.startsWith('#')) {
                            const targetElement = document.querySelector(href);
                            if (targetElement) {
                                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                                window.scrollTo({
                                    top: targetPosition,
                                    behavior: 'smooth'
                                });
                            }
                        }
                    });
                });
            }
        },

        toggleSidebarMobile: function () {
            document.addEventListener('click', (event) => {
                const sidebarTrigger = event.target.closest('[data-sidebar]');
                if (sidebarTrigger) {
                    event.preventDefault();
                    event.stopPropagation();
                    document.body.classList.add('open-mobile-sidebar');
                }
            });

            document.addEventListener('click', (event) => {
                const closeSidebar = event.target.closest('[data-close-sidebar]');
                if (closeSidebar) {
                    event.preventDefault();
                    event.stopPropagation();
                    document.body.classList.remove('open-mobile-sidebar');
                }
            });

            document.addEventListener('click', (event) => {
                if ($body.classList.contains('open-mobile-sidebar')) {
                    const clickedSidebar = event.target.closest('[data-sidebar]');
                    const clickedHaloSidebar = event.target.closest('#halo-sidebar');
                    if (!clickedSidebar && !clickedHaloSidebar) {
                        $body.classList.remove('open-mobile-sidebar');
                    }
                }
            });
        },

        initBlogMasonry: function () {
            const blogMasonry = document.querySelectorAll('.blog-layout-masonry .blog-block-item');
            const isRTL = $body.classList.contains('layout_rtl');

            if (blogMasonry.length && typeof Masonry !== 'undefined') {
                blogMasonry.forEach(function (element) {
                    new Masonry(element, {
                        columnWidth: '.blog-grid-sizer',
                        itemSelector: '[data-masonry-item]',
                        isRTL: isRTL,
                        originLeft: !isRTL
                    });
                });
            }
        },

        articleGallery: function () {
            // Use Swiper module if available
            if (typeof window.initAllArticleGalleries === 'function') {
                window.initAllArticleGalleries();
            }
        },

        initCollapseSidebarBlock: function () {
            document.addEventListener('click', (event) => {
                const target = event.target.closest('.sidebarBlock-headingWrapper .sidebarBlock-heading');
                if (!target) return;

                const parent = target.parentElement;
                if (!parent) return;

                const blockCollapse = parent.nextElementSibling;
                const sidebarBlock = target.closest('.sidebarBlock');

                if (target.classList.contains('is-clicked')) {
                    target.classList.remove('is-clicked');
                    if (blockCollapse) {
                        blockCollapse.style.maxHeight = '0';
                        blockCollapse.style.overflow = 'hidden';
                        blockCollapse.style.transition = 'max-height 0.5s ease-out';
                    }
                } else {
                    target.classList.add('is-clicked');
                    if (blockCollapse) {
                        blockCollapse.style.maxHeight = blockCollapse.scrollHeight + 'px';
                        blockCollapse.style.overflow = 'visible';
                        blockCollapse.style.transition = 'max-height 0.5s ease-in';
                    }

                    if (sidebarBlock && sidebarBlock.classList.contains('sidebar-product')) {
                        const productsCarousel = sidebarBlock.querySelector('.products-carousel');
                        if (productsCarousel && productsCarousel.swiperInstance) {
                            productsCarousel.swiperInstance.update();
                        }
                    }
                }
            });

            document.addEventListener('click', (event) => {
                const target = event.target.closest('.sidebarBlock-headingWrapper-slide .sidebarBlock-heading');
                if (!target) return;

                const parent = target.parentElement;
                if (!parent) return;

                const blockSlide = parent.nextElementSibling;
                const wrapBlock = target.closest(".halo-sidebar-wrapper");
                const sidebarBlock = target.closest('.sidebarBlock');

                if (!blockSlide || !wrapBlock || !sidebarBlock) return;

                blockSlide.classList.toggle("is-show");
                wrapBlock.classList.toggle("disable-scroll");
                sidebarBlock.classList.toggle("has-slide");

                const backButton = blockSlide.querySelector(".sidebarBlock-slide__content-close");
                if (backButton) {
                    backButton.addEventListener("click", function () {
                        blockSlide.classList.remove("is-show");
                        wrapBlock.classList.remove("disable-scroll");
                        sidebarBlock.classList.remove("has-slide");
                    }, { once: true });
                }
            });
        },

        initCategoryActive: function () {
            const allCategoriesList = document.querySelectorAll('.all-categories-list');
            if (allCategoriesList.length > 0) {
                document.addEventListener('click', (event) => {
                    const iconDropdown = event.target.closest('.all-categories-list .icon-dropdown');
                    if (!iconDropdown) return;

                    const target = iconDropdown.parentElement;
                    if (!target) return;

                    const siblings = Array.from(target.parentElement.children).filter(child => child !== target);
                    siblings.forEach(sibling => {
                        sibling.classList.remove('is-clicked', 'current-cate');
                        const dropdown = sibling.querySelector('> .dropdown-category-list');
                        if (dropdown) {
                            dropdown.style.maxHeight = '0';
                            dropdown.style.overflow = 'hidden';
                            dropdown.style.transition = 'max-height 0.5s ease-out';
                        }
                    });

                    target.classList.toggle('is-clicked');
                    const targetDropdown = target.querySelector('> .dropdown-category-list');
                    if (targetDropdown) {
                        if (target.classList.contains('is-clicked')) {
                            targetDropdown.style.maxHeight = targetDropdown.scrollHeight + 'px';
                            targetDropdown.style.overflow = 'visible';
                            targetDropdown.style.transition = 'max-height 0.5s ease-in';
                        } else {
                            targetDropdown.style.maxHeight = '0';
                            targetDropdown.style.overflow = 'hidden';
                            targetDropdown.style.transition = 'max-height 0.5s ease-out';
                        }
                    }
                });

                document.querySelectorAll('.all-categories-list li').forEach((element) => {
                    if (element.classList.contains('current-cate')) {
                        const dropdown = element.querySelector('> .dropdown-category-list');
                        if (dropdown) {
                            dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
                            dropdown.style.overflow = 'visible';
                            dropdown.style.transition = 'max-height 0.5s ease-in';
                        }
                    }
                    if (element.classList.contains("is-clicked")) {
                        const navPagesItem = element.closest(".navPages-item");
                        if (navPagesItem) navPagesItem.classList.add("is-clicked");
                        const parent = element.parentElement;
                        if (parent) {
                            parent.style.maxHeight = parent.scrollHeight + 'px';
                            parent.style.overflow = 'visible';
                            parent.style.transition = 'max-height 0.5s ease-in';
                        }
                    }
                });
            }
        },

        productBlockSilderSidebar: function () {
            // Use Swiper module if available
            const productGrid = document.querySelector('[data-product-slider-sidebar]');
            if (productGrid && typeof window.initProductBlockSlider === 'function') {
                const wrapper = productGrid.closest('.halo-sidebar-wrapper') || productGrid.parentElement;
                if (wrapper) {
                    const swiper = window.initProductBlockSlider(wrapper);
                    if (swiper) {
                        // Enable autoplay for sidebar
                        if (swiper.autoplay) {
                            swiper.autoplay.start();
                        }
                        if (document.body.classList.contains('cursor-fixed__show')) {
                            window.sharedFunctionsAnimation.onEnterButton();
                            window.sharedFunctionsAnimation.onLeaveButton();
                        }
                        return;
                    }
                }
            }

            if (document.body.classList.contains('cursor-fixed__show')) {
                window.sharedFunctionsAnimation.onEnterButton();
                window.sharedFunctionsAnimation.onLeaveButton();
            }
        },

        productBlockSilderArticle: function () {
            // Use Swiper module if available
            const productGrid = document.querySelector('[data-product-slider-article]');
            if (productGrid && typeof window.initProductBlockSlider === 'function') {
                const wrapper = productGrid.closest('.article-content') || productGrid.parentElement;
                if (wrapper) {
                    const swiper = window.initProductBlockSlider(wrapper);
                    if (swiper) {
                        return;
                    }
                }
            }
        },

        // All Infinite Scrolling functions moved to infinite-scrolling.js module
        // initInfiniteScrolling, doAjaxInfiniteScrollingGetContent, ajaxInfiniteScrollingMapData
        // See: assets/infinite-scrolling.js

        // doAjaxInfiniteScrollingGetContent moved to infinite-scrolling.js

        // ajaxInfiniteScrollingMapData moved to infinite-scrolling.js

        // initQuickShopProductList moved to quick-shop.js

        // updateContentQuickShop moved to quick-shop.js

        // All Express Order functions moved to express-order.js module
        // toggleVariantsForExpressOrder, initExpressOrderAddToCart, expressAjaxAddToCart
        // See: assets/express-order.js

        // initExpressOrderAddToCart moved to express-order.js

        // expressAjaxAddToCart moved to express-order.js

        initProductBundle: function () {
            // Product bundle functionality - Slick removed
            const productBundle = document.querySelector('[data-product-bundle]');
            if (!productBundle) return;

            const bundleWrapper = productBundle.querySelector('.bundle-product-wrapper');
            if (bundleWrapper) {
                bundleWrapper.classList.remove('has-halo-block-loader');
            }

            console.warn('Product bundle slider needs Swiper implementation');
        },

        initDynamicBrowserTabTitle: function () {
            if (window.dynamic_browser_title.show) {
                var pageTitleContent = document.title,
                    newPageTitleContent = window.dynamic_browser_title.text;

                window.onblur = function () {
                    document.title = window.dynamic_browser_title.text;
                }

                window.onfocus = function () {
                    document.title = pageTitleContent;
                }
            }
        },

        // All Warning Popup functions moved to warning-popup.js module
        // initWarningPopup, showWarning
        // See: assets/warning-popup.js

        // showWarning moved to warning-popup.js

        backgroundOverlayHoverEffect: function () {
            const backgroundOverlay = document.querySelector('.background-overlay')
            const backgroundCursorWrapper = backgroundOverlay.firstChild

            const enlargeCursor = () => {
                backgroundCursorWrapper.classList.add('enlarge-cursor')
            }

            const dwindleCursor = () => {
                backgroundCursorWrapper.classList.remove('enlarge-cursor')
            }

            const setCursorPosition = (clientX, clientY) => {
                requestAnimationFrame(() => {
                    backgroundCursorWrapper.style.setProperty('--translate-y', clientY)
                    backgroundCursorWrapper.style.setProperty('--translate-x', clientX)
                })
            }

            const handleMouseMove = (e) => {
                setCursorPosition(e.clientX, e.clientY)
            }

            const handleMouseEnter = (e) => {
                setCursorPosition(e.clientX, e.clientY)
                enlargeCursor()
            }

            const handleMouseLeave = e => {
                setCursorPosition(e.clientX, e.clientY)
                backgroundCursorWrapper.removeEventListener('mousemove', handleMouseMove)
                dwindleCursor()
            }

            backgroundOverlay.addEventListener('mouseenter', handleMouseEnter)
            backgroundOverlay.addEventListener('mouseleave', handleMouseLeave)
            backgroundOverlay.addEventListener('mousemove', handleMouseMove)
            backgroundOverlay.addEventListener('click', dwindleCursor)
        },

        initCentralizedOverlay: function () {
            const overlay = document.querySelector('.background-overlay');
            if (overlay) {
                overlay.addEventListener('click', (e) => {
                    // Centralized handler to close all sidebars/drawers
                    const sidebars = [
                        'open_search_mobile',
                        'menu_open',
                        'cart_open',
                        'open_search_menu',
                        'quick-view-open',
                        'quick-shop-open',
                        'newsletter-open',
                        'tab-popup-show',
                        'tab-popup-sidebar-show',
                        'compare-color-show',
                        'ask-an-expert-show',
                        'size-chart-show',
                        'modal-share-open'
                    ];

                    document.body.classList.remove(...sidebars);

                    // Specific cleanup for tabs and other non-body-class elements
                    document.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
                    document.querySelector('.toggle-content.is-show')?.classList.remove('is-show');

                    // Newsletter popup cleanup
                    const newsletterPopup = document.querySelector('.newsletter-success-modal');
                    if (newsletterPopup) newsletterPopup.style.display = 'none';
                    overlay.style.display = 'none'; // Ensure overlay itself is hidden if it was shown via style
                }, { passive: true });
            }
        },
        backgroundOverlayHoverEffect1: function () {
            const backgroundOverlay = document.querySelector('.background-overlay1')
            if (!backgroundOverlay) return;

            const backgroundCursorWrapper = backgroundOverlay.firstChild

            const enlargeCursor = () => {
                backgroundCursorWrapper.classList.add('enlarge-cursor')
            }

            const dwindleCursor = () => {
                backgroundCursorWrapper.classList.remove('enlarge-cursor')
            }

            const setCursorPosition = (clientX, clientY) => {
                requestAnimationFrame(() => {
                    backgroundCursorWrapper.style.setProperty('--translate-y', clientY)
                    backgroundCursorWrapper.style.setProperty('--translate-x', clientX)
                })
            }

            const handleMouseMove = (e) => {
                setCursorPosition(e.clientX, e.clientY)
            }

            const handleMouseEnter = (e) => {
                setCursorPosition(e.clientX, e.clientY)
                enlargeCursor()
            }

            const handleMouseLeave = e => {
                setCursorPosition(e.clientX, e.clientY)
                backgroundCursorWrapper.removeEventListener('mousemove', handleMouseMove)
                dwindleCursor()
            }

            backgroundOverlay.addEventListener('mouseenter', handleMouseEnter)
            backgroundOverlay.addEventListener('mouseleave', handleMouseLeave)
            backgroundOverlay.addEventListener('mousemove', handleMouseMove)
            backgroundOverlay.addEventListener('click', dwindleCursor)
        },

        productCustomInformation() {
            const customInfoElements = document.querySelectorAll('[data-custom-information]');
            const thisPopup = document.getElementById('halo-product-custom-information');
            if (!thisPopup) return;

            customInfoElements.forEach(element => {
                element.addEventListener('click', (event) => {
                    const titleEl = element.querySelector('.title');
                    const contentEl = element.querySelector('.product-customInformation__popup');
                    if (!titleEl || !contentEl) return;

                    const title = titleEl.textContent || titleEl.innerText;
                    const thisContent = contentEl.innerHTML;

                    if (thisContent === "" || thisContent == null) return;
                    thisPopup.classList.add('is-show');
                    const popupTitle = thisPopup.querySelector('.halo-popup-title');
                    const popupContent = thisPopup.querySelector('.halo-popup-content');
                    if (popupTitle) popupTitle.textContent = title;
                    if (popupContent) popupContent.innerHTML = thisContent;
                    $body.classList.add('is-custom-information');
                });
            });

            document.addEventListener('click', (event) => {
                const closeBtn = event.target.closest('[data-close-custom-information]');
                if (closeBtn) {
                    $body.classList.remove('is-custom-information');
                    thisPopup.classList.remove('is-show');
                }
            });

            document.addEventListener('click', (event) => {
                if ($body.classList.contains('is-custom-information')) {
                    const popup = event.target.closest('#halo-product-custom-information');
                    const customInfo = event.target.closest('[data-custom-information]');
                    if (!popup && !customInfo) {
                        $body.classList.remove('is-custom-information');
                    }
                }
            });
        },

        initLazyloadObserver(loadingImages, productGrid) {
            const setLazyLoaded = (target) => {
                const card = target.closest('.card')
                card.classList.add('ajax-loaded')
            }

            this.lazyloadedObserver = new MutationObserver((mutationList, observer) => {
                mutationList.forEach((mutation) => {
                    if (mutation.type == 'attributes') {
                        if (!mutation.target.classList.contains('lazyloaded')) return
                        setLazyLoaded(mutation.target)
                    }
                })
            })

            const parentObserver = new MutationObserver((mutationlist) => {
                mutationlist.forEach((mutation) => {
                    if (mutation.type == 'childList') {
                        const addedLoadingImages = [...mutation.addedNodes].map(node => node.querySelector('.media--loading-effect img'))
                        addedLoadingImages.forEach(image => {
                            if (image) {
                                this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
                            }
                        })
                    }
                })
            })

            if (productGrid) parentObserver.observe(productGrid, { subtree: false, childList: true });
            if (loadingImages.length > 0) loadingImages.forEach(image => {
                if (image.classList.contains('lazyloaded')) {
                    setLazyLoaded(image)
                } else {
                    this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
                }
            })
        },

        observeImageLazyloaded(images) {
            images.forEach(image => {
                this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
            })
        },

        iconZoomClickMobile() {
            const iconZoomElements = document.querySelectorAll('.productView-iconZoom');
            iconZoomElements.forEach(iconZoom => {
                iconZoom.addEventListener('click', (event) => {
                    const media = document.querySelector('.productView-image .productView-img-container .media');
                    if (media) media.click();
                });
            });
        },

        calculateTranslateYHeight() {
            const cardActions = document.querySelectorAll('.card .card-action:not(.variants-popup-form)');
            let heighest = 0;

            if (!cardActions.length) return;
            cardActions.forEach(cardAction => {
                cardAction.classList.add('temporary-show');

                const height = cardAction.clientHeight;
                if (height > heighest) heighest = height;

                cardAction.classList.remove('temporary-show');
            })
            document.body.style.setProperty('--translate-y-height', heighest * -1 + 'px');
        },

        checkScrollLayoutForRecenlyViewed() {
            const RecentlyViewedSection = document.getElementById('recently-viewed-products-list-2');

            if (RecentlyViewedSection && RecentlyViewedSection.classList.contains('products-flex')) {
                const RecentlyViewedObserver = new MutationObserver((mutationList, observer) => {
                    const mutationRecentlyViewed = mutationList[0];

                    if (mutationRecentlyViewed.type == 'attributes'
                        && mutationRecentlyViewed.target.classList.contains('recently-viewed-loaded')) {

                        observer.disconnect();
                    }
                })

                RecentlyViewedObserver.observe(RecentlyViewedSection, { attributes: true });
            }
        },

        clickIconScrollSection() {
            if (!document.querySelector('.arrow-icon-scroll')) return;
            let isScrollingDown = 'next';
            const sections = document.querySelectorAll('.wrapper-body .shopify-section'),
                sectionsLength = sections.length,
                sectionFirstHeight = sections[0]?.getBoundingClientRect().height || 0,
                sectionEndHeight = sections[sectionsLength - 1]?.getBoundingClientRect().height || 0,
                footerHeight = document.querySelectorAll('.shopify-section-group-footer-group')[0]?.getBoundingClientRect().height || 0;

            if (window.pageYOffset + sectionEndHeight >= document.documentElement.scrollHeight - footerHeight) loadRotateArrow('prev');

            window.addEventListener('scroll', function () {
                if (window.pageYOffset + sectionEndHeight >= document.documentElement.scrollHeight - footerHeight) loadRotateArrow('prev');
                else if (window.pageYOffset <= sectionFirstHeight / 2) loadRotateArrow('next');
            });

            document.addEventListener('click', (event) => {
                const arrowIcon = event.target.closest('.arrow-icon-scroll');
                if (!arrowIcon) return;
                let checkScroll = true;
                const headerHeight = window.innerWidth > 1024 ? document.querySelectorAll('sticky-header')[0]?.getBoundingClientRect().height : document.querySelector('sticky-header-mobile')?.getBoundingClientRect().height || 0,
                    footerTop = document.querySelectorAll('.shopify-section-group-footer-group')[0]?.getBoundingClientRect().top || -1;

                sections.forEach((element, index) => {
                    if (!checkScroll) return;
                    const thisTop = element.getBoundingClientRect().top;

                    if (thisTop >= 0) {
                        checkScroll = false;

                        if (isScrollingDown == 'next') {
                            if (element.nextElementSibling != null) scrollToSection(element.nextElementSibling.offsetTop - headerHeight);
                            sectionsLength == index + 2 || element.nextElementSibling == null ? loadRotateArrow('prev') : loadRotateArrow('next');
                        }
                        else {
                            if (element.previousElementSibling != null) scrollToSection(element.previousElementSibling.offsetTop - headerHeight);
                            index == 1 || element.previousElementSibling == null ? loadRotateArrow('next') : loadRotateArrow('prev');
                        }
                    }
                    else if (footerTop >= 0) scrollToSection(sections[sectionsLength - 1].offsetTop - headerHeight);
                });
            });

            function scrollToSection(scope, rotate) {
                window.scrollTo({ top: scope, behavior: "smooth" });
            }

            function loadRotateArrow(rotate) {
                isScrollingDown = rotate;
                rotate == 'next' ? document.querySelector('.arrow-icon-scroll').classList.remove('rotate') : document.querySelector('.arrow-icon-scroll').classList.add('rotate');
            }
        },

        specialBanner() {
            const banners = document.querySelectorAll('[sticky-special-banner]'),
                wdWidth = window.innerWidth,
                wdHeight = window.innerHeight,
                headerHeight = wdWidth > 1024 ? document.querySelectorAll('sticky-header')[0]?.getBoundingClientRect().height : document.querySelector('sticky-header-mobile')?.getBoundingClientRect().height || 0;

            if (banners) {
                banners.forEach(element => {
                    const banner = element.querySelector('.special-banner__img_box'),
                        bannerWrap = element.querySelector('.special-banner__img'),
                        wrapperHeight = element.closest('.special-banner__wrapper').getBoundingClientRect().height,
                        bannerHeight = bannerWrap.getBoundingClientRect().height;

                    let top = headerHeight || 0;
                    if (wdWidth >= 1200) {
                        if (wrapperHeight > bannerHeight) {
                            if (wdHeight > bannerHeight) top = (wdHeight - bannerHeight) / 2;
                            calculateSticky(banner, top);
                        }
                    }
                    else if (wdWidth >= 768 && wdWidth < 1200) {
                        if (wrapperHeight > bannerHeight) {
                            calculateSticky(banner, top);
                        }
                    }
                    else {
                        element.classList.remove('is-sticky');
                        element.style.top = ``;
                    }
                });
            }

            function calculateSticky(banner, top) {
                banner.classList.add('is-sticky');
                banner.style.top = `${top}px`;
            }
        },

        specialBannerSlider() {
            // Use Swiper module if available
            if (typeof window.initAllSpecialBannerSliders === 'function') {
                window.initAllSpecialBannerSliders();
                return;
            }

            // Fallback: Use Slick (temporary)
            const productGrids = document.querySelectorAll('.special-banner__products--grid');
            const wdWidth = window.innerWidth;

            if (productGrids.length > 0) {
                productGrids.forEach((element) => {
                    const block = element.closest('.special-banner__product');
                    if (!block || !block.classList.contains('ajax-loaded')) return;

                    if (wdWidth < 1200) {
                        if (!element.classList.contains('swiper-initialized')) {
                            element.classList.add('products-carousel');
                            specialProductSlider(block);
                        }
                    }
                    else {
                        if (element.classList.contains('swiper-initialized')) {
                            // Destroy Swiper instance
                            if (element.swiperInstance) {
                                element.swiperInstance.destroy(true, true);
                                element.swiperInstance = null;
                            }
                            element.classList.remove('products-carousel');
                            element.classList.remove('swiper-initialized');
                        }
                    }
                });
            }

            function specialProductSlider(wrapper) {
                // Use Swiper module if available
                if (typeof window.initAllSpecialBannerSliders === 'function') {
                    window.initAllSpecialBannerSliders();
                }
            }

        },

        unsymmetricalSlider() {
            // Use Swiper module if available (already in product-block-swiper.js)
            if (typeof window.initProductBlockSlider === 'function') {
                const productUnsy = document.querySelectorAll('.unsymmetrical-slider');
                const wdWidth = window.innerWidth;

                if (productUnsy.length > 0) {
                    productUnsy.forEach((element) => {
                        const block = element.closest('.halo-block-content');
                        if (!block || !block.classList.contains('ajax-loaded')) return;

                        if (wdWidth < 1200) {
                            // Check if element is already initialized with Swiper or Slick (legacy check)
                            if (!element.classList.contains('swiper-initialized') && !element.classList.contains('slick-initialized')) {
                                element.classList.add('products-carousel');
                                setTimeout(() => {
                                    const swiper = window.initProductBlockSlider(block);
                                    if (swiper) {
                                        // Handle progress bar if needed
                                        if (element.classList.contains('enable_progress_bar')) {
                                            const progressBar = block.querySelector('.scrollbar-thumb');
                                            if (progressBar) {
                                                swiper.on('slideChange', () => {
                                                    const percent = ((swiper.activeIndex / (swiper.slides.length - 1)) * 100) + '%';
                                                    progressBar.style.setProperty('--percent', percent);
                                                });
                                            }
                                        }
                                    }
                                }, 1000);
                            }
                        }
                        else {
                            if (element.classList.contains('swiper-initialized')) {
                                const swiper = element.swiperInstance;
                                if (swiper) {
                                    swiper.destroy(true, true);
                                }
                                element.classList.remove('swiper-initialized', 'products-carousel');
                            }
                        }
                    });
                }
                return;
            }

            // Fallback: Use Slick (temporary)
            const productUnsy = document.querySelectorAll('.unsymmetrical-slider');
            const wdWidth = window.innerWidth;

            if (productUnsy.length > 0) {
                productUnsy.forEach((element) => {
                    const block = element.closest('.halo-block-content');
                    if (!block || !block.classList.contains('ajax-loaded')) return;

                    // Element is already a DOM element, no conversion needed

                    if (wdWidth < 1200) {
                        if (!element.classList.contains('swiper-initialized')) {
                            element.classList.add('products-carousel');
                            setTimeout(() => {
                                unsymmetricalProductSlider(block);
                            }, 1000);
                        }
                    }
                    else {
                        if (element.classList.contains('swiper-initialized')) {
                            // Destroy Swiper instance
                            if (element.swiperInstance) {
                                element.swiperInstance.destroy(true, true);
                                element.swiperInstance = null;
                            }
                            element.classList.remove('products-carousel');
                            element.classList.remove('swiper-initialized');
                        }
                    }
                });

                function unsymmetricalProductSlider(wrapper) {
                    // Use Swiper module (already implemented in product-block-swiper.js)
                    if (typeof window.initProductBlockSlider === 'function') {
                        window.initProductBlockSlider(wrapper);
                    }
                }
            }
        },

        productCountdownCard: function () {
            const cardCountDown = document.querySelectorAll('.card .card-countDown');
            if (!cardCountDown.length) return;

            cardCountDown.forEach(card => {
                const wrapper = card.querySelector('[data-countdown-id]');
                if (!wrapper) return;

                var countDown = wrapper.dataset.countdown,
                    countDownDate = new Date(countDown).getTime(),
                    countDownText = window.countdown.text;

                if (isNaN(countDownDate)) return;

                var countdownfunction = setInterval(function () {
                    var now = new Date().getTime(),
                        distance = countDownDate - now;

                    if (distance < 0) {
                        clearInterval(countdownfunction);
                        wrapper.remove();
                    } else {
                        var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                            seconds = Math.floor((distance % (1000 * 60)) / 1000),
                            strCountDown;

                        strCountDown = '<span class="text"><span>' + countDownText + '</span></span><span class="num">' + days + '<span>' + window.countdown.day + '</span></span>\
                                <span class="num">'+ hours + '<span class="icon">:</span></span>\
                                <span class="num">'+ minutes + '<span class="icon">:</span></span>\
                                <span class="num">'+ seconds + '</span>';

                        wrapper.innerHTML = strCountDown;
                        wrapper.classList.add('show');
                    }
                }, 1000);
            });
        },

        typingAnimation() {
            // typing multiple text
            var TextType = function (element, rotate, period) {
                this.rotate = rotate;
                this.element = element;
                this.loopNum = 0;
                this.period = parseInt(period, 10) || 2000;
                this.text = '';
                this.tick();
                this.isDeleting = false;
            };

            TextType.prototype.tick = function () {
                var i = this.loopNum % this.rotate.length;
                var fullText = this.rotate[i];

                if (this.isDeleting) {
                    this.text = fullText.substring(0, this.text.length - 1);
                } else {
                    this.text = fullText.substring(0, this.text.length + 1);
                }

                const textConvert = this.element.querySelector('[data-text-convert]');
                if (textConvert) textConvert.innerHTML = `<span class="text">${this.text}</span>`;

                var that = this;
                var delta = 200 - Math.random() * 100;

                if (this.isDeleting) {
                    delta /= 2;
                }

                if (!this.isDeleting && this.text === fullText) {
                    delta = this.period;
                    this.isDeleting = true;
                } else if (this.isDeleting && this.text === '') {
                    this.isDeleting = false;
                    this.loopNum++;
                    delta = 500;
                }

                setTimeout(function () {
                    that.tick();
                }, delta);
            };

            // typing full text and split with comma
            var MultipleSentencesType = function (element, period) {
                this.element = element;
                this.sentences = JSON.parse(this.element.getAttribute('data-type'));
                this.period = parseInt(period, 10) || 2000;
                this.sentenceIndex = 0;
                this.setupCurrentSentence();
                this.isDeleting = false;
                this.isPaused = false;
                this.tick();
            };

            MultipleSentencesType.prototype.setupCurrentSentence = function () {
                this.currentTextArray = this.sentences[this.sentenceIndex].split(',').map(word => word.trim());
                this.fullTextArray = this.currentTextArray;
                this.displayedWords = this.currentTextArray.map(() => '');
            };

            MultipleSentencesType.prototype.tick = function () {
                var that = this;
                var completedTextArray = this.fullTextArray;

                if (!this.isDeleting && !this.isPaused) {
                    for (let i = 0; i < this.currentTextArray.length; i++) {
                        if (this.displayedWords[i] !== completedTextArray[i]) {
                            this.displayedWords[i] = completedTextArray[i].substring(0, this.displayedWords[i].length + 1);
                            break;
                        }
                    }

                    if (this.displayedWords.join(' ') === completedTextArray.join(' ')) {
                        this.isPaused = true;
                        setTimeout(function () {
                            that.isPaused = false;
                            that.isDeleting = true;
                        }, 1000);
                    }
                } else if (this.isDeleting) {
                    for (let i = this.currentTextArray.length - 1; i >= 0; i--) {
                        if (this.displayedWords[i] !== '') {
                            this.displayedWords[i] = this.displayedWords[i].substring(0, this.displayedWords[i].length - 1);
                            break;
                        }
                    }

                    if (this.displayedWords.join('') === '') {
                        this.isDeleting = false;
                        this.sentenceIndex = (this.sentenceIndex + 1) % this.sentences.length;
                        this.setupCurrentSentence();
                    }
                }

                var spans = this.displayedWords.map(word => `<span class="text">${word}</span>`).join(' ');
                this.element.innerHTML = spans;

                var delta = 150 - Math.random() * 50;
                if (this.isPaused) {
                    delta = this.period;
                } else if (this.isDeleting && this.displayedWords.join('') === '') {
                    delta = 500;
                }

                setTimeout(function () {
                    that.tick();
                }, delta);
            };

            //use
            const typeWriterElements = document.querySelectorAll('type-writer');
            if (typeWriterElements.length) {
                typeWriterElements.forEach(function (el) {
                    const rotate = el.getAttribute('data-type');
                    const period = el.getAttribute('data-period');

                    if (el.classList.contains('typing-comma')) {
                        new MultipleSentencesType(el, period);
                    } else {
                        if (rotate) {
                            new TextType(el, JSON.parse(rotate), period);
                        }
                    }
                });
            }


        },

        spotlightproductSlider: function () {
            // Use Swiper module if available
            // O módulo spotlight-product-swiper.js se auto-inicializa quando carregado
            // Esta função só é chamada se o módulo já estiver disponível
            if (typeof window.initAllSpotlightProductSliders === 'function') {
                window.initAllSpotlightProductSliders();
            }
            // Não mostrar warning - o módulo se auto-inicializa quando carregado com defer
        },

        activeCheckboxStickyCartMobile: function () {
            var enableSticky = document.querySelectorAll('.enable_sticky_buttton');
            if (!enableSticky.length) return;

            var buttonDisable = document.querySelectorAll('.button-disable'),
                stickyButtonMB = document.querySelector('.sticky_button_checkout_mb'),
                haloStickyToolbar = document.querySelector('.halo-sticky-toolbar-mobile');

            if (!stickyButtonMB) return;

            var heightToolbar = haloStickyToolbar ? haloStickyToolbar.offsetHeight : 0;

            buttonDisable.forEach(btn => {
                btn.addEventListener('click', function () {
                    stickyButtonMB.classList.add('active');
                });
            });

            if (haloStickyToolbar) {
                stickyButtonMB.style.bottom = heightToolbar + 'px';
            } else {
                stickyButtonMB.style.bottom = '0px';
            }
        }
    };

    // Export halo object to window
    window.halo = window.halo || {};
    Object.assign(window.halo, halo);

    // Initialize halo after object definition
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            halo.ready();
        });
    } else {
        halo.ready();
    }

    document.addEventListener("DOMContentLoaded", function () {
        halo.init();
    });

    window.updateCart = function (cart) {
        // Tentar halo.updateSidebarCart primeiro (como no backup)
        if (halo.updateSidebarCart && typeof halo.updateSidebarCart === 'function') {
            halo.updateSidebarCart(cart);
        }
        // Fallback para window.sharedFunctions.updateSidebarCart (exportado explicitamente pelo cart-sidebar.js)
        else if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart && typeof window.sharedFunctions.updateSidebarCart === 'function') {
            window.sharedFunctions.updateSidebarCart(cart);
        }
        document.body.classList.add("cart-sidebar-show");
    };

    // Captura o parametro da URL atual
    var queryString = window.location.search;
    var searchParams = new URLSearchParams(queryString);

    // Verifique se o parâmetro 'cart-show' está presente
    var cartOpen = searchParams.has("cart_show");

    if (cartOpen) {
        Shopify.getCart((cart) => {
            // Cart loaded
            window.updateCart(cart);
        });

        var url = window.location.href;
        var urlObj = new URL(url);

        urlObj.search = "";
        window.history.replaceState({}, document.title, urlObj.href);
    }
})();
